webpackJsonp([35783957827783],{

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	
	var _Avatar = _interopRequireDefault(__webpack_require__(421));

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var styles = function styles(theme) {
	  return {
	    root: theme.mixins.gutters({
	      paddingTop: theme.spacing.unit * 2,
	      paddingBottom: theme.spacing.unit * 2,
	      '&:last-child': {
	        paddingBottom: theme.spacing.unit * 3
	      }
	    })
	  };
	};
	
	exports.styles = styles;
	
	function CardContent(props) {
	  var classes = props.classes,
	      className = props.className,
	      Component = props.component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, className)
	  }, other));
	}
	
	CardContent.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : {};
	CardContent.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardContent'
	})(CardContent);
	
	exports.default = _default;

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	
	var _CardContent = _interopRequireDefault(__webpack_require__(235));

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _helpers = __webpack_require__(35);
	
	var SIZE = 50;
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return (clampedValue - min) / (max - min);
	}
	
	function easeOut(t) {
	  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294
	
	  t = (t -= 1) * t * t + 1;
	  return t;
	}
	
	function easeIn(t) {
	  return t * t;
	}
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'inline-block'
	    },
	    static: {
	      transition: theme.transitions.create('transform')
	    },
	    indeterminate: {
	      animation: 'mui-progress-circular-rotate 1.4s linear infinite'
	    },
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	    svg: {},
	    circle: {
	      stroke: 'currentColor',
	      strokeLinecap: 'round'
	    },
	    circleStatic: {
	      transition: theme.transitions.create('stroke-dashoffset')
	    },
	    circleIndeterminate: {
	      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
	      // Some default value that looks fine waiting for the animation to kicks in.
	      strokeDasharray: '80px, 200px',
	      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
	
	    },
	    '@keyframes mui-progress-circular-rotate': {
	      '100%': {
	        transform: 'rotate(360deg)'
	      }
	    },
	    '@keyframes mui-progress-circular-dash': {
	      '0%': {
	        strokeDasharray: '1px, 200px',
	        strokeDashoffset: '0px'
	      },
	      '50%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-15px'
	      },
	      '100%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-120px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	
	function CircularProgress(props) {
	  var _classNames, _classNames2;
	
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      size = props.size,
	      style = props.style,
	      thickness = props.thickness,
	      value = props.value,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "size", "style", "thickness", "value", "variant"]);
	  var circleStyle = {};
	  var rootStyle = {};
	  var rootProps = {};
	
	  if (variant === 'determinate' || variant === 'static') {
	    var circumference = 2 * Math.PI * (SIZE / 2 - 5);
	    circleStyle.strokeDasharray = circumference.toFixed(3);
	    rootProps['aria-valuenow'] = Math.round(value);
	
	    if (variant === 'static') {
	      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
	      rootStyle.transform = 'rotate(-90deg)';
	    } else {
	      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
	      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
	    }
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes.indeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames, classes.static, variant === 'static'), _classNames), className),
	    style: (0, _objectSpread2.default)({
	      width: size,
	      height: size
	    }, rootStyle, style),
	    role: "progressbar"
	  }, rootProps, other), _react.default.createElement("svg", {
	    className: classes.svg,
	    viewBox: "0 0 ".concat(SIZE, " ").concat(SIZE)
	  }, _react.default.createElement("circle", {
	    className: (0, _classnames.default)(classes.circle, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.circleIndeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames2, classes.circleStatic, variant === 'static'), _classNames2)),
	    style: circleStyle,
	    cx: SIZE / 2,
	    cy: SIZE / 2,
	    r: SIZE / 2 - 5,
	    fill: "none",
	    strokeWidth: thickness
	  })));
	}
	
	CircularProgress.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary', 'inherit']),
	
	  /**
	   * The size of the circle.
	   */
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The thickness of the circle.
	   */
	  thickness: _propTypes.default.number,
	
	  /**
	   * The value of the progress indicator for the determinate and static variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The variant of progress indicator. Use indeterminate
	   * when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
	} : {};
	CircularProgress.defaultProps = {
	  color: 'primary',
	  size: 40,
	  thickness: 3.6,
	  value: 0,
	  variant: 'indeterminate'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCircularProgress',
	  flip: false
	})(CircularProgress);
	
	exports.default = _default;

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	
	var _CircularProgress = _interopRequireDefault(__webpack_require__(237));

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var styles = {
	  root: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    overflowY: 'auto',
	    listStyle: 'none',
	    padding: 0,
	    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
	
	  }
	};
	exports.styles = styles;
	
	function GridList(props) {
	  var cellHeight = props.cellHeight,
	      children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      cols = props.cols,
	      Component = props.component,
	      spacing = props.spacing,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, classNameProp),
	    style: (0, _objectSpread2.default)({
	      margin: -spacing / 2
	    }, style)
	  }, other), _react.default.Children.map(children, function (currentChild) {
	    if (!_react.default.isValidElement(currentChild)) {
	      return null;
	    }
	
	    var childCols = currentChild.props.cols || 1;
	    var childRows = currentChild.props.rows || 1;
	    return _react.default.cloneElement(currentChild, {
	      style: (0, _extends2.default)({
	        width: "".concat(100 / cols * childCols, "%"),
	        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
	        padding: spacing / 2
	      }, currentChild.props.style)
	    });
	  }));
	}
	
	GridList.propTypes =  false ? {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
	
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Number of columns.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Number of px for the spacing between tiles.
	   */
	  spacing: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : {};
	GridList.defaultProps = {
	  cellHeight: 180,
	  cols: 2,
	  component: 'ul',
	  spacing: 4
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridList'
	})(GridList);
	
	exports.default = _default;

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	
	var _GridList = _interopRequireDefault(__webpack_require__(436));

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(82));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(18));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(93));
	
	var _debounce = _interopRequireDefault(__webpack_require__(124));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var styles = {
	  root: {
	    boxSizing: 'border-box',
	    flexShrink: 0
	  },
	  tile: {
	    position: 'relative',
	    display: 'block',
	    // In case it's not renderd with a div.
	    height: '100%',
	    overflow: 'hidden'
	  },
	  imgFullHeight: {
	    height: '100%',
	    transform: 'translateX(-50%)',
	    position: 'relative',
	    left: '50%'
	  },
	  imgFullWidth: {
	    width: '100%',
	    position: 'relative',
	    transform: 'translateY(-50%)',
	    top: '50%'
	  }
	};
	exports.styles = styles;
	
	var GridListTile =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(GridListTile, _React$Component);
	
	  function GridListTile() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, GridListTile);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = GridListTile.__proto__ || (0, _getPrototypeOf.default)(GridListTile)).call.apply(_ref, [this].concat(args))), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "imgElement", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: null
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "handleResize", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: (0, _debounce.default)(function () {
	        _this.fit();
	      }, 166)
	    }), Object.defineProperty((0, _assertThisInitialized2.default)(_this), "fit", {
	      configurable: true,
	      enumerable: true,
	      writable: true,
	      value: function value() {
	        var imgElement = _this.imgElement;
	
	        if (!imgElement) {
	          return;
	        }
	
	        if (!imgElement.complete) {
	          return;
	        }
	
	        if (imgElement.width / imgElement.height > imgElement.parentNode.offsetWidth / imgElement.parentNode.offsetHeight) {
	          var _imgElement$classList, _imgElement$classList2;
	
	          (_imgElement$classList = imgElement.classList).remove.apply(_imgElement$classList, (0, _toConsumableArray2.default)(_this.props.classes.imgFullWidth.split(' ')));
	
	          (_imgElement$classList2 = imgElement.classList).add.apply(_imgElement$classList2, (0, _toConsumableArray2.default)(_this.props.classes.imgFullHeight.split(' ')));
	        } else {
	          var _imgElement$classList3, _imgElement$classList4;
	
	          (_imgElement$classList3 = imgElement.classList).remove.apply(_imgElement$classList3, (0, _toConsumableArray2.default)(_this.props.classes.imgFullHeight.split(' ')));
	
	          (_imgElement$classList4 = imgElement.classList).add.apply(_imgElement$classList4, (0, _toConsumableArray2.default)(_this.props.classes.imgFullWidth.split(' ')));
	        }
	
	        imgElement.removeEventListener('load', _this.fit);
	      }
	    }), _temp));
	  }
	
	  (0, _createClass2.default)(GridListTile, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	    }
	  }, {
	    key: "ensureImageCover",
	    value: function ensureImageCover() {
	      if (!this.imgElement) {
	        return;
	      }
	
	      if (this.imgElement.complete) {
	        this.fit();
	      } else {
	        this.imgElement.addEventListener('load', this.fit);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          classes = _props.classes,
	          className = _props.className,
	          cols = _props.cols,
	          Component = _props.component,
	          rows = _props.rows,
	          other = (0, _objectWithoutProperties2.default)(_props, ["children", "classes", "className", "cols", "component", "rows"]);
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        className: (0, _classnames.default)(classes.root, className)
	      }, other), _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onResize: this.handleResize
	      }), _react.default.createElement("div", {
	        className: classes.tile
	      }, _react.default.Children.map(children, function (child) {
	        if (child && child.type === 'img') {
	          return _react.default.cloneElement(child, {
	            key: 'img',
	            ref: function ref(node) {
	              _this2.imgElement = node;
	            }
	          });
	        }
	
	        return child;
	      })));
	    }
	  }]);
	  return GridListTile;
	}(_react.default.Component);
	
	GridListTile.propTypes =  false ? {
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in which case GridListTile takes care of making the image "cover" available space
	   * (similar to `background-size: cover` or to `object-fit: cover`).
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _propTypes.default.number
	} : {};
	GridListTile.defaultProps = {
	  cols: 1,
	  component: 'li',
	  rows: 1
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTile'
	})(GridListTile);
	
	exports.default = _default;

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTile.default;
	  }
	});
	
	var _GridListTile = _interopRequireDefault(__webpack_require__(438));

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'absolute',
	      left: 0,
	      right: 0,
	      height: 48,
	      background: 'rgba(0, 0, 0, 0.4)',
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: theme.typography.fontFamily
	    },
	    titlePositionBottom: {
	      bottom: 0
	    },
	    titlePositionTop: {
	      top: 0
	    },
	    rootSubtitle: {
	      height: 68
	    },
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: theme.mixins.gutters().paddingLeft,
	      marginRight: theme.mixins.gutters().paddingRight,
	      color: theme.palette.common.white,
	      overflow: 'hidden'
	    },
	    titleWrapActionPosLeft: {
	      marginLeft: 0
	    },
	    titleWrapActionPosRight: {
	      marginRight: 0
	    },
	    title: {
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: '24px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    subtitle: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1,
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    actionIcon: {},
	    actionIconActionPosLeft: {
	      order: -1
	    }
	  };
	};
	
	exports.styles = styles;
	
	function GridListTileBar(props) {
	  var _classNames, _classNames2;
	
	  var actionIcon = props.actionIcon,
	      actionPosition = props.actionPosition,
	      classes = props.classes,
	      classNameProp = props.className,
	      subtitle = props.subtitle,
	      title = props.title,
	      titlePosition = props.titlePosition,
	      other = (0, _objectWithoutProperties2.default)(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);
	  var actionPos = actionIcon && actionPosition;
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.titlePositionBottom, titlePosition === 'bottom'), (0, _defineProperty2.default)(_classNames, classes.titlePositionTop, titlePosition === 'top'), (0, _defineProperty2.default)(_classNames, classes.rootSubtitle, subtitle), _classNames), classNameProp); // Remove the margin between the title / subtitle wrapper, and the Action Icon
	
	  var titleWrapClassName = (0, _classnames.default)(classes.titleWrap, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.titleWrapActionPosLeft, actionPos === 'left'), (0, _defineProperty2.default)(_classNames2, classes.titleWrapActionPosRight, actionPos === 'right'), _classNames2));
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className
	  }, other), _react.default.createElement("div", {
	    className: titleWrapClassName
	  }, _react.default.createElement("div", {
	    className: classes.title
	  }, title), subtitle ? _react.default.createElement("div", {
	    className: classes.subtitle
	  }, subtitle) : null), actionIcon ? _react.default.createElement("div", {
	    className: (0, _classnames.default)(classes.actionIcon, (0, _defineProperty2.default)({}, classes.actionIconActionPosLeft, actionPos === 'left'))
	  }, actionIcon) : null);
	}
	
	GridListTileBar.propTypes =  false ? {
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _propTypes.default.node,
	
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _propTypes.default.oneOf(['left', 'right']),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _propTypes.default.node,
	
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * Position of the title bar.
	   */
	  titlePosition: _propTypes.default.oneOf(['top', 'bottom'])
	} : {};
	GridListTileBar.defaultProps = {
	  actionPosition: 'right',
	  titlePosition: 'bottom'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTileBar'
	})(GridListTileBar);
	
	exports.default = _default;

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTileBar.default;
	  }
	});
	
	var _GridListTileBar = _interopRequireDefault(__webpack_require__(440));

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _warning = _interopRequireDefault(__webpack_require__(14));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _colorManipulator = __webpack_require__(55);
	
	var TRANSITION_DURATION = 4; // seconds
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      overflow: 'hidden',
	      height: 5
	    },
	    colorPrimary: {
	      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
	    },
	    colorSecondary: {
	      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
	    },
	    buffer: {
	      backgroundColor: 'transparent'
	    },
	    query: {
	      transform: 'rotate(180deg)'
	    },
	    dashed: {
	      position: 'absolute',
	      marginTop: 0,
	      height: '100%',
	      width: '100%',
	      animation: 'buffer 3s infinite linear'
	    },
	    dashedColorPrimary: {
	      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	    dashedColorSecondary: {
	      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6), " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	    bar: {
	      width: '100%',
	      position: 'absolute',
	      left: 0,
	      bottom: 0,
	      top: 0,
	      transition: 'transform 0.2s linear',
	      transformOrigin: 'left'
	    },
	    barColorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	    barColorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	    bar1Indeterminate: {
	      width: 'auto',
	      willChange: 'left, right',
	      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
	    },
	    bar2Indeterminate: {
	      width: 'auto',
	      willChange: 'left, right',
	      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
	      animationDelay: '1.15s'
	    },
	    bar1Determinate: {
	      willChange: 'transform',
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    bar1Buffer: {
	      zIndex: 1,
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    bar2Buffer: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    // Legends:
	    // || represents the viewport
	    // -  represents a light background
	    // x  represents a dark background
	    '@keyframes mui-indeterminate1': {
	      //  |-----|---x-||-----||-----|
	      '0%': {
	        left: '-35%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||xxxx-|
	      '60%': {
	        left: '100%',
	        right: '-90%'
	      },
	      '100%': {
	        left: '100%',
	        right: '-90%'
	      }
	    },
	    '@keyframes mui-indeterminate2': {
	      //  |xxxxx|xxxxx||-----||-----|
	      '0%': {
	        left: '-200%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||-x----|
	      '60%': {
	        left: '107%',
	        right: '-8%'
	      },
	      '100%': {
	        left: '107%',
	        right: '-8%'
	      }
	    },
	    '@keyframes buffer': {
	      '0%': {
	        opacity: 1,
	        backgroundPosition: '0px -23px'
	      },
	      '50%': {
	        opacity: 0,
	        backgroundPosition: '0px -23px'
	      },
	      '100%': {
	        opacity: 1,
	        backgroundPosition: '-200px -23px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	
	function LinearProgress(props) {
	  var _classNames, _classNames2, _classNames3, _classNames4;
	
	  var classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      value = props.value,
	      valueBuffer = props.valueBuffer,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.colorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.colorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.buffer, variant === 'buffer'), (0, _defineProperty2.default)(_classNames, classes.query, variant === 'query'), _classNames), classNameProp);
	  var dashedClass = (0, _classnames.default)(classes.dashed, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.dashedColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames2, classes.dashedColorSecondary, color === 'secondary'), _classNames2));
	  var bar1ClassName = (0, _classnames.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.barColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames3, classes.barColorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames3, classes.bar1Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames3, classes.bar1Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames3, classes.bar1Buffer, variant === 'buffer'), _classNames3));
	  var bar2ClassName = (0, _classnames.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.barColorPrimary, color === 'primary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorPrimary, color === 'primary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.barColorSecondary, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorSecondary, color === 'secondary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.bar2Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames4, classes.bar2Buffer, variant === 'buffer'), _classNames4));
	  var rootProps = {};
	  var inlineStyles = {
	    bar1: {},
	    bar2: {}
	  };
	
	  if (variant === 'determinate' || variant === 'buffer') {
	    if (value !== undefined) {
	      rootProps['aria-valuenow'] = Math.round(value);
	      inlineStyles.bar1.transform = "scaleX(".concat(value / 100, ")");
	    } else {
	       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
	    }
	  }
	
	  if (variant === 'buffer') {
	    if (valueBuffer !== undefined) {
	      inlineStyles.bar2.transform = "scaleX(".concat((valueBuffer || 0) / 100, ")");
	    } else {
	       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
	    }
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: className,
	    role: "progressbar"
	  }, rootProps, other), variant === 'buffer' ? _react.default.createElement("div", {
	    className: dashedClass
	  }) : null, _react.default.createElement("div", {
	    className: bar1ClassName,
	    style: inlineStyles.bar1
	  }), variant === 'determinate' ? null : _react.default.createElement("div", {
	    className: bar2ClassName,
	    style: inlineStyles.bar2
	  }));
	}
	
	LinearProgress.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The value of the progress indicator for the determinate and buffer variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The value for the buffer variant.
	   * Value between 0 and 100.
	   */
	  valueBuffer: _propTypes.default.number,
	
	  /**
	   * The variant of progress indicator. Use indeterminate or query
	   * when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
	} : {};
	LinearProgress.defaultProps = {
	  color: 'primary',
	  variant: 'indeterminate'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLinearProgress'
	})(LinearProgress);
	
	exports.default = _default;

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(158));

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(19));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _getPrototypeOf = _interopRequireDefault(__webpack_require__(15));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(12));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(13));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(17));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(16));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(94));
	
	var _reactHelpers = __webpack_require__(168);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left'
	    },
	    container: {
	      position: 'relative'
	    },
	    focusVisible: {
	      backgroundColor: theme.palette.action.hover
	    },
	    default: {
	      paddingTop: 12,
	      paddingBottom: 12
	    },
	    dense: {
	      paddingTop: theme.spacing.unit,
	      paddingBottom: theme.spacing.unit
	    },
	    disabled: {
	      opacity: 0.5
	    },
	    divider: {
	      borderBottom: "1px solid ".concat(theme.palette.divider),
	      backgroundClip: 'padding-box'
	    },
	    gutters: theme.mixins.gutters(),
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positionned.
	      paddingRight: theme.spacing.unit * 4
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ListItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ListItem, _React$Component);
	
	  function ListItem() {
	    (0, _classCallCheck2.default)(this, ListItem);
	    return (0, _possibleConstructorReturn2.default)(this, (ListItem.__proto__ || (0, _getPrototypeOf.default)(ListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(ListItem, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        dense: this.props.dense || this.context.dense || false
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          button = _props.button,
	          childrenProp = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          componentProp = _props.component,
	          ContainerComponent = _props.ContainerComponent,
	          _props$ContainerProps = _props.ContainerProps;
	      _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
	      var ContainerClassName = _props$ContainerProps.className,
	          ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
	          dense = _props.dense,
	          disabled = _props.disabled,
	          disableGutters = _props.disableGutters,
	          divider = _props.divider,
	          other = (0, _objectWithoutProperties2.default)(_props, ["button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider"]);
	      var isDense = dense || this.context.dense || false;
	
	      var children = _react.default.Children.toArray(childrenProp);
	
	      var hasAvatar = children.some(function (value) {
	        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
	      });
	      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
	      var className = (0, _classnames.default)(classes.root, isDense || hasAvatar ? classes.dense : classes.default, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty2.default)(_classNames, classes.divider, divider), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.button, button), (0, _defineProperty2.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);
	      var componentProps = (0, _objectSpread2.default)({
	        className: className,
	        disabled: disabled
	      }, other);
	      var Component = componentProp || 'li';
	
	      if (button) {
	        componentProps.component = componentProp || 'div';
	        componentProps.focusVisibleClassName = classes.focusVisible;
	        Component = _ButtonBase.default;
	      }
	
	      if (hasSecondaryAction) {
	        // Use div by default.
	        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
	
	        if (ContainerComponent === 'li') {
	          if (Component === 'li') {
	            Component = 'div';
	          } else if (componentProps.component === 'li') {
	            componentProps.component = 'div';
	          }
	        }
	
	        return _react.default.createElement(ContainerComponent, (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.container, ContainerClassName)
	        }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop());
	      }
	
	      return _react.default.createElement(Component, componentProps, children);
	    }
	  }]);
	  return ListItem;
	}(_react.default.Component);
	
	ListItem.propTypes =  false ? {
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`).
	   */
	  button: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * The container component used when a `ListItemSecondaryAction` is rendered.
	   */
	  ContainerComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Properties applied to the container element when the component
	   * is used to display a `ListItemSecondaryAction`.
	   */
	  ContainerProps: _propTypes.default.object,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes.default.bool
	} : {};
	ListItem.defaultProps = {
	  button: false,
	  ContainerComponent: 'li',
	  dense: false,
	  disabled: false,
	  disableGutters: false,
	  divider: false
	};
	ListItem.contextTypes = {
	  dense: _propTypes.default.bool
	};
	ListItem.childContextTypes = {
	  dense: _propTypes.default.bool
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItem'
	})(ListItem);
	
	exports.default = _default;

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	
	var _ListItem = _interopRequireDefault(__webpack_require__(443));

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(8));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(10));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(7));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(5));
	
	var _Typography = _interopRequireDefault(__webpack_require__(11));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      flex: '1 1 auto',
	      minWidth: 0,
	      padding: "0 ".concat(theme.spacing.unit * 2, "px"),
	      '&:first-child': {
	        paddingLeft: 0
	      }
	    },
	    inset: {
	      '&:first-child': {
	        paddingLeft: theme.spacing.unit * 7
	      }
	    },
	    dense: {
	      fontSize: theme.typography.pxToRem(13)
	    },
	    primary: {
	      '&$textDense': {
	        fontSize: 'inherit'
	      }
	    },
	    secondary: {
	      '&$textDense': {
	        fontSize: 'inherit'
	      }
	    },
	    textDense: {}
	  };
	};
	
	exports.styles = styles;
	
	function ListItemText(props, context) {
	  var _classNames3;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      disableTypography = props.disableTypography,
	      inset = props.inset,
	      primaryProp = props.primary,
	      secondaryProp = props.secondary,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "secondary"]);
	  var dense = context.dense;
	  var primary = primaryProp || children;
	
	  if (primary && !disableTypography) {
	    primary = _react.default.createElement(_Typography.default, {
	      variant: "subheading",
	      className: (0, _classnames.default)(classes.primary, (0, _defineProperty2.default)({}, classes.textDense, dense))
	    }, primary);
	  }
	
	  var secondary = secondaryProp;
	
	  if (secondary && !disableTypography) {
	    secondary = _react.default.createElement(_Typography.default, {
	      variant: "body1",
	      className: (0, _classnames.default)(classes.secondary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
	      color: "textSecondary"
	    }, secondary);
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.dense, dense), (0, _defineProperty2.default)(_classNames3, classes.inset, inset), _classNames3), classNameProp)
	  }, other), primary, secondary);
	}
	
	ListItemText.propTypes =  false ? {
	  /**
	   * Alias for the `primary` property.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a typography component.
	   * For instance, that can be useful to can render an h4 instead of a
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * If `true`, the children will be indented.
	   * This should be used if there is no left avatar or left icon.
	   */
	  inset: _propTypes.default.bool,
	  primary: _propTypes.default.node,
	  secondary: _propTypes.default.node
	} : {};
	ListItemText.defaultProps = {
	  disableTypography: false,
	  inset: false
	};
	ListItemText.contextTypes = {
	  dense: _propTypes.default.bool
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemText'
	})(ListItemText);
	
	exports.default = _default;

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(4);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	
	var _ListItemText = _interopRequireDefault(__webpack_require__(445));

/***/ }),

/***/ 1047:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.2.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: function() {
	    return this.rgb().hex();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: function() {
	    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://beta.observablehq.com/@mbostock/lab-and-rgb
	var K = 18;
	var Xn = 0.96422;
	var Yn = 1;
	var Zn = 0.82521;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.lch = lch;
	exports.gray = gray;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 1048:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-ease/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI;
	var halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11;
	var b2 = 6 / 11;
	var b3 = 8 / 11;
	var b4 = 3 / 4;
	var b5 = 9 / 11;
	var b6 = 10 / 11;
	var b7 = 15 / 16;
	var b8 = 21 / 22;
	var b9 = 63 / 64;
	var b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI;
	var amplitude = 1;
	var period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	exports.easeLinear = linear;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 1049:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.2.0. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1047)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var frame = 0;
	var timeout = 0;
	var interval = 0;
	var pokeDelay = 1000;
	var taskHead;
	var taskTail;
	var clockLast = 0;
	var clockNow = 0;
	var clockSkew = 0;
	var clock = typeof performance === "object" && performance.now ? performance : Date;
	var setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	var timeout$1 = function(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	};
	
	var interval$1 = function(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	};
	
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(1070);
	var each = __webpack_require__(800).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),

/***/ 1069:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(1068);
	var Util = __webpack_require__(800);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),

/***/ 800:
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(1069);
	module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 3983:
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(4271);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),

/***/ 3984:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 4041:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4043).default;
	module.exports.default = module.exports;


/***/ }),

/***/ 4042:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PagingDots = exports.NextButton = exports.PreviousButton = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var defaultButtonStyles = function defaultButtonStyles(disabled) {
	  return {
	    border: 0,
	    background: 'rgba(0,0,0,0.4)',
	    color: 'white',
	    padding: 10,
	    outline: 0,
	    opacity: disabled ? 0.3 : 1,
	    cursor: disabled ? 'not-allowed' : 'pointer'
	  };
	};
	
	var PreviousButton =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(PreviousButton, _React$Component);
	
	  function PreviousButton() {
	    var _this;
	
	    _classCallCheck(this, PreviousButton);
	
	    _this = _possibleConstructorReturn(this, (PreviousButton.__proto__ || Object.getPrototypeOf(PreviousButton)).apply(this, arguments));
	    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(PreviousButton, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault();
	      this.props.previousSlide();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var disabled = this.props.currentSlide === 0 && !this.props.wrapAround || this.props.slideCount === 0;
	      return _react.default.createElement("button", {
	        style: defaultButtonStyles(disabled),
	        disabled: disabled,
	        onClick: this.handleClick
	      }, "PREV");
	    }
	  }]);
	
	  return PreviousButton;
	}(_react.default.Component);
	
	exports.PreviousButton = PreviousButton;
	
	var NextButton =
	/*#__PURE__*/
	function (_React$Component2) {
	  _inherits(NextButton, _React$Component2);
	
	  function NextButton() {
	    var _this2;
	
	    _classCallCheck(this, NextButton);
	
	    _this2 = _possibleConstructorReturn(this, (NextButton.__proto__ || Object.getPrototypeOf(NextButton)).apply(this, arguments));
	    _this2.handleClick = _this2.handleClick.bind(_assertThisInitialized(_this2));
	    return _this2;
	  }
	
	  _createClass(NextButton, [{
	    key: "handleClick",
	    value: function handleClick(event) {
	      event.preventDefault();
	      this.props.nextSlide();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var disabled = this.props.currentSlide + this.props.slidesToScroll >= this.props.slideCount && !this.props.wrapAround;
	      return _react.default.createElement("button", {
	        style: defaultButtonStyles(disabled),
	        disabled: disabled,
	        onClick: this.handleClick
	      }, "NEXT");
	    }
	  }]);
	
	  return NextButton;
	}(_react.default.Component);
	
	exports.NextButton = NextButton;
	
	var PagingDots =
	/*#__PURE__*/
	function (_React$Component3) {
	  _inherits(PagingDots, _React$Component3);
	
	  function PagingDots() {
	    _classCallCheck(this, PagingDots);
	
	    return _possibleConstructorReturn(this, (PagingDots.__proto__ || Object.getPrototypeOf(PagingDots)).apply(this, arguments));
	  }
	
	  _createClass(PagingDots, [{
	    key: "getIndexes",
	    value: function getIndexes(count, inc) {
	      var arr = [];
	
	      for (var i = 0; i < count; i += inc) {
	        arr.push(i);
	      }
	
	      return arr;
	    }
	  }, {
	    key: "getListStyles",
	    value: function getListStyles() {
	      return {
	        position: 'relative',
	        margin: 0,
	        top: -10,
	        padding: 0
	      };
	    }
	  }, {
	    key: "getListItemStyles",
	    value: function getListItemStyles() {
	      return {
	        listStyleType: 'none',
	        display: 'inline-block'
	      };
	    }
	  }, {
	    key: "getButtonStyles",
	    value: function getButtonStyles(active) {
	      return {
	        border: 0,
	        background: 'transparent',
	        color: 'black',
	        cursor: 'pointer',
	        padding: 10,
	        outline: 0,
	        fontSize: 24,
	        opacity: active ? 1 : 0.5
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var indexes = this.getIndexes(this.props.slideCount, this.props.slidesToScroll);
	      return _react.default.createElement("ul", {
	        style: this.getListStyles()
	      }, indexes.map(function (index) {
	        return _react.default.createElement("li", {
	          style: _this3.getListItemStyles(),
	          key: index
	        }, _react.default.createElement("button", {
	          style: _this3.getButtonStyles(_this3.props.currentSlide === index),
	          onClick: _this3.props.goToSlide.bind(null, index)
	        }, "\u2022"));
	      }));
	    }
	  }]);
	
	  return PagingDots;
	}(_react.default.Component);
	
	exports.PagingDots = PagingDots;

/***/ }),

/***/ 4043:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "PagingDots", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.PagingDots;
	  }
	});
	Object.defineProperty(exports, "PreviousButton", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.PreviousButton;
	  }
	});
	Object.defineProperty(exports, "NextButton", {
	  enumerable: true,
	  get: function get() {
	    return _defaultControls.NextButton;
	  }
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _exenv = _interopRequireDefault(__webpack_require__(801));
	
	var _Animate = _interopRequireDefault(__webpack_require__(4067));
	
	var easing = _interopRequireWildcard(__webpack_require__(1048));
	
	var _defaultControls = __webpack_require__(4042);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var addEvent = function addEvent(elem, type, eventHandle) {
	  if (elem === null || typeof elem === 'undefined') {
	    return;
	  }
	
	  if (elem.addEventListener) {
	    elem.addEventListener(type, eventHandle, false);
	  } else if (elem.attachEvent) {
	    elem.attachEvent("on".concat(type), eventHandle);
	  } else {
	    elem["on".concat(type)] = eventHandle;
	  }
	};
	
	var removeEvent = function removeEvent(elem, type, eventHandle) {
	  if (elem === null || typeof elem === 'undefined') {
	    return;
	  }
	
	  if (elem.removeEventListener) {
	    elem.removeEventListener(type, eventHandle, false);
	  } else if (elem.detachEvent) {
	    elem.detachEvent("on".concat(type), eventHandle);
	  } else {
	    elem["on".concat(type)] = null;
	  }
	};
	
	var Carousel =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Carousel, _React$Component);
	
	  function Carousel() {
	    var _this;
	
	    _classCallCheck(this, Carousel);
	
	    _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).apply(this, arguments));
	    _this.displayName = 'Carousel';
	    _this.clickSafe = true;
	    _this.controlsMap = [{
	      func: _this.props.renderTopLeftControls,
	      key: 'TopLeft'
	    }, {
	      func: _this.props.renderTopCenterControls,
	      key: 'TopCenter'
	    }, {
	      func: _this.props.renderTopRightControls,
	      key: 'TopRight'
	    }, {
	      func: _this.props.renderCenterLeftControls,
	      key: 'CenterLeft'
	    }, {
	      func: _this.props.renderCenterCenterControls,
	      key: 'CenterCenter'
	    }, {
	      func: _this.props.renderCenterRightControls,
	      key: 'CenterRight'
	    }, {
	      func: _this.props.renderBottomLeftControls,
	      key: 'BottomLeft'
	    }, {
	      func: _this.props.renderBottomCenterControls,
	      key: 'BottomCenter'
	    }, {
	      func: _this.props.renderBottomRightControls,
	      key: 'BottomRight'
	    }];
	    _this.touchObject = {};
	    _this.state = {
	      currentSlide: _this.props.slideIndex,
	      dragging: false,
	      frameWidth: 0,
	      left: 0,
	      slideCount: 0,
	      slidesToScroll: _this.props.slidesToScroll,
	      slideWidth: 0,
	      top: 0,
	      easing: easing.easeCircleOut,
	      isWrappingAround: false,
	      wrapToIndex: null,
	      resetWrapAroundPosition: false
	    };
	    _this.getTouchEvents = _this.getTouchEvents.bind(_assertThisInitialized(_this));
	    _this.getMouseEvents = _this.getMouseEvents.bind(_assertThisInitialized(_this));
	    _this.handleMouseOver = _this.handleMouseOver.bind(_assertThisInitialized(_this));
	    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_this));
	    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
	    _this.handleSwipe = _this.handleSwipe.bind(_assertThisInitialized(_this));
	    _this.swipeDirection = _this.swipeDirection.bind(_assertThisInitialized(_this));
	    _this.autoplayIterator = _this.autoplayIterator.bind(_assertThisInitialized(_this));
	    _this.startAutoplay = _this.startAutoplay.bind(_assertThisInitialized(_this));
	    _this.stopAutoplay = _this.stopAutoplay.bind(_assertThisInitialized(_this));
	    _this.resetAutoplay = _this.resetAutoplay.bind(_assertThisInitialized(_this));
	    _this.goToSlide = _this.goToSlide.bind(_assertThisInitialized(_this));
	    _this.nextSlide = _this.nextSlide.bind(_assertThisInitialized(_this));
	    _this.previousSlide = _this.previousSlide.bind(_assertThisInitialized(_this));
	    _this.getTargetLeft = _this.getTargetLeft.bind(_assertThisInitialized(_this));
	    _this.onResize = _this.onResize.bind(_assertThisInitialized(_this));
	    _this.onReadyStateChange = _this.onReadyStateChange.bind(_assertThisInitialized(_this));
	    _this.onVisibilityChange = _this.onVisibilityChange.bind(_assertThisInitialized(_this));
	    _this.setInitialDimensions = _this.setInitialDimensions.bind(_assertThisInitialized(_this));
	    _this.setDimensions = _this.setDimensions.bind(_assertThisInitialized(_this));
	    _this.setLeft = _this.setLeft.bind(_assertThisInitialized(_this));
	    _this.getListStyles = _this.getListStyles.bind(_assertThisInitialized(_this));
	    _this.getFrameStyles = _this.getFrameStyles.bind(_assertThisInitialized(_this));
	    _this.getSlideStyles = _this.getSlideStyles.bind(_assertThisInitialized(_this));
	    _this.getSlideTargetPosition = _this.getSlideTargetPosition.bind(_assertThisInitialized(_this));
	    _this.getSliderStyles = _this.getSliderStyles.bind(_assertThisInitialized(_this));
	    _this.getOffsetDeltas = _this.getOffsetDeltas.bind(_assertThisInitialized(_this));
	    _this.formatChildren = _this.formatChildren.bind(_assertThisInitialized(_this));
	    _this.getChildNodes = _this.getChildNodes.bind(_assertThisInitialized(_this));
	    _this.getSlideHeight = _this.getSlideHeight.bind(_assertThisInitialized(_this));
	    _this.findMaxHeightSlide = _this.findMaxHeightSlide.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  _createClass(Carousel, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      this.setInitialDimensions();
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
	      this.mounted = true;
	      this.setDimensions();
	      this.bindEvents();
	
	      if (this.props.autoplay) {
	        this.startAutoplay();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var slideCount = _react.default.Children.count(nextProps.children);
	
	      this.setState({
	        slideCount: slideCount
	      });
	
	      if (slideCount <= this.state.currentSlide) {
	        this.goToSlide(Math.max(slideCount - 1, 0));
	      }
	
	      this.setDimensions(nextProps);
	
	      if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide && !this.state.isWrappingAround) {
	        this.goToSlide(nextProps.slideIndex);
	      }
	
	      if (this.props.autoplay !== nextProps.autoplay) {
	        if (nextProps.autoplay) {
	          this.startAutoplay();
	        } else {
	          this.stopAutoplay();
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unbindEvents();
	      this.stopAutoplay(); // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
	
	      this.mounted = false;
	    }
	  }, {
	    key: "getTouchEvents",
	    value: function getTouchEvents() {
	      var _this2 = this;
	
	      if (this.props.swiping === false) {
	        return null;
	      }
	
	      return {
	        onTouchStart: function onTouchStart(e) {
	          _this2.touchObject = {
	            startX: e.touches[0].pageX,
	            startY: e.touches[0].pageY
	          };
	
	          _this2.handleMouseOver();
	        },
	        onTouchMove: function onTouchMove(e) {
	          var direction = _this2.swipeDirection(_this2.touchObject.startX, e.touches[0].pageX, _this2.touchObject.startY, e.touches[0].pageY);
	
	          if (direction !== 0) {
	            e.preventDefault();
	          }
	
	          var length = _this2.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - _this2.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - _this2.touchObject.startX, 2)));
	          _this2.touchObject = {
	            startX: _this2.touchObject.startX,
	            startY: _this2.touchObject.startY,
	            endX: e.touches[0].pageX,
	            endY: e.touches[0].pageY,
	            length: length,
	            direction: direction
	          };
	
	          _this2.setState({
	            left: _this2.props.vertical ? 0 : _this2.getTargetLeft(_this2.touchObject.length * _this2.touchObject.direction),
	            top: _this2.props.vertical ? _this2.getTargetLeft(_this2.touchObject.length * _this2.touchObject.direction) : 0
	          });
	        },
	        onTouchEnd: function onTouchEnd(e) {
	          _this2.handleSwipe(e);
	
	          _this2.handleMouseOut();
	        },
	        onTouchCancel: function onTouchCancel(e) {
	          _this2.handleSwipe(e);
	        }
	      };
	    }
	  }, {
	    key: "getMouseEvents",
	    value: function getMouseEvents() {
	      var _this3 = this;
	
	      if (this.props.dragging === false) {
	        return null;
	      }
	
	      return {
	        onMouseOver: function onMouseOver() {
	          return _this3.handleMouseOver();
	        },
	        onMouseOut: function onMouseOut() {
	          return _this3.handleMouseOut();
	        },
	        onMouseDown: function onMouseDown(e) {
	          _this3.touchObject = {
	            startX: e.clientX,
	            startY: e.clientY
	          };
	
	          _this3.setState({
	            dragging: true
	          });
	        },
	        onMouseMove: function onMouseMove(e) {
	          if (!_this3.state.dragging) {
	            return;
	          }
	
	          var direction = _this3.swipeDirection(_this3.touchObject.startX, e.clientX, _this3.touchObject.startY, e.clientY);
	
	          if (direction !== 0) {
	            e.preventDefault();
	          }
	
	          var length = _this3.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - _this3.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - _this3.touchObject.startX, 2)));
	          _this3.touchObject = {
	            startX: _this3.touchObject.startX,
	            startY: _this3.touchObject.startY,
	            endX: e.clientX,
	            endY: e.clientY,
	            length: length,
	            direction: direction
	          };
	
	          _this3.setState({
	            left: _this3.props.vertical ? 0 : _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction),
	            top: _this3.props.vertical ? _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction) : 0
	          });
	        },
	        onMouseUp: function onMouseUp(e) {
	          if (!_this3.state.dragging) {
	            return;
	          }
	
	          _this3.handleSwipe(e);
	        },
	        onMouseLeave: function onMouseLeave(e) {
	          if (!_this3.state.dragging) {
	            return;
	          }
	
	          _this3.handleSwipe(e);
	        }
	      };
	    }
	  }, {
	    key: "pauseAutoplay",
	    value: function pauseAutoplay() {
	      if (this.props.autoplay) {
	        this.autoplayPaused = true;
	        this.stopAutoplay();
	      }
	    }
	  }, {
	    key: "unpauseAutoplay",
	    value: function unpauseAutoplay() {
	      if (this.props.autoplay && this.autoplayPaused) {
	        this.startAutoplay();
	        this.autoplayPaused = null;
	      }
	    }
	  }, {
	    key: "handleMouseOver",
	    value: function handleMouseOver() {
	      this.pauseAutoplay();
	    }
	  }, {
	    key: "handleMouseOut",
	    value: function handleMouseOut() {
	      this.unpauseAutoplay();
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      if (this.clickSafe === true) {
	        event.preventDefault();
	        event.stopPropagation();
	
	        if (event.nativeEvent) {
	          event.nativeEvent.stopPropagation();
	        }
	      }
	    }
	  }, {
	    key: "handleSwipe",
	    value: function handleSwipe() {
	      if (typeof this.touchObject.length !== 'undefined' && this.touchObject.length > 44) {
	        this.clickSafe = true;
	      } else {
	        this.clickSafe = false;
	      }
	
	      var slidesToShow = this.props.slidesToShow;
	
	      if (this.props.slidesToScroll === 'auto') {
	        slidesToShow = this.state.slidesToScroll;
	      }
	
	      if (this.touchObject.length > this.state.slideWidth / slidesToShow / 5) {
	        if (this.touchObject.direction === 1) {
	          if (this.state.currentSlide >= _react.default.Children.count(this.props.children) - slidesToShow && !this.props.wrapAround) {
	            this.setState({
	              easing: easing[this.props.edgeEasing]
	            });
	          } else {
	            this.nextSlide();
	          }
	        } else if (this.touchObject.direction === -1) {
	          if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
	            this.setState({
	              easing: easing[this.props.edgeEasing]
	            });
	          } else {
	            this.previousSlide();
	          }
	        }
	      } else {
	        this.goToSlide(this.state.currentSlide);
	      }
	
	      this.touchObject = {};
	      this.setState({
	        dragging: false
	      });
	    }
	  }, {
	    key: "swipeDirection",
	    value: function swipeDirection(x1, x2, y1, y2) {
	      var xDist = x1 - x2;
	      var yDist = y1 - y2;
	      var r = Math.atan2(yDist, xDist);
	      var swipeAngle = Math.round(r * 180 / Math.PI);
	
	      if (swipeAngle < 0) {
	        swipeAngle = 360 - Math.abs(swipeAngle);
	      }
	
	      if (swipeAngle <= 45 && swipeAngle >= 0) {
	        return 1;
	      }
	
	      if (swipeAngle <= 360 && swipeAngle >= 315) {
	        return 1;
	      }
	
	      if (swipeAngle >= 135 && swipeAngle <= 225) {
	        return -1;
	      }
	
	      if (this.props.vertical === true) {
	        if (swipeAngle >= 35 && swipeAngle <= 135) {
	          return 1;
	        } else {
	          return -1;
	        }
	      }
	
	      return 0;
	    }
	  }, {
	    key: "autoplayIterator",
	    value: function autoplayIterator() {
	      if (this.props.wrapAround) {
	        this.nextSlide();
	        return;
	      }
	
	      if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
	        this.nextSlide();
	      } else {
	        this.stopAutoplay();
	      }
	    }
	  }, {
	    key: "startAutoplay",
	    value: function startAutoplay() {
	      this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
	    }
	  }, {
	    key: "resetAutoplay",
	    value: function resetAutoplay() {
	      if (this.props.autoplay && !this.autoplayPaused) {
	        this.stopAutoplay();
	        this.startAutoplay();
	      }
	    }
	  }, {
	    key: "stopAutoplay",
	    value: function stopAutoplay() {
	      if (this.autoplayID) {
	        clearInterval(this.autoplayID);
	      }
	    } // Action Methods
	
	  }, {
	    key: "goToSlide",
	    value: function goToSlide(index) {
	      var _this4 = this;
	
	      this.setState({
	        easing: easing[this.props.easing]
	      });
	
	      if (index >= _react.default.Children.count(this.props.children) || index < 0) {
	        if (!this.props.wrapAround) {
	          return;
	        }
	
	        if (index >= _react.default.Children.count(this.props.children)) {
	          this.props.beforeSlide(this.state.currentSlide, 0);
	          this.setState(function (prevState) {
	            return {
	              left: _this4.props.vertical ? 0 : _this4.getTargetLeft(_this4.state.slideWidth, prevState.currentSlide),
	              top: _this4.props.vertical ? _this4.getTargetLeft(_this4.state.slideWidth, prevState.currentSlide) : 0,
	              currentSlide: 0,
	              isWrappingAround: true,
	              wrapToIndex: index
	            };
	          }, function () {
	            return setTimeout(function () {
	              _this4.setState({
	                isWrappingAround: false,
	                resetWrapAroundPosition: true
	              }, function () {
	                _this4.setState({
	                  resetWrapAroundPosition: false
	                });
	
	                _this4.props.afterSlide(0);
	
	                _this4.resetAutoplay();
	              });
	            }, _this4.props.speed);
	          });
	          return;
	        } else {
	          var endSlide = _react.default.Children.count(this.props.children) - this.state.slidesToScroll;
	          this.props.beforeSlide(this.state.currentSlide, endSlide);
	          this.setState(function (prevState) {
	            return {
	              left: _this4.props.vertical ? 0 : _this4.getTargetLeft(-1, prevState.currentSlide),
	              top: _this4.props.vertical ? _this4.getTargetLeft(-1, prevState.currentSlide) : 0,
	              currentSlide: endSlide,
	              isWrappingAround: true,
	              wrapToIndex: index
	            };
	          }, function () {
	            return setTimeout(function () {
	              _this4.setState({
	                isWrappingAround: false,
	                resetWrapAroundPosition: true
	              }, function () {
	                _this4.setState({
	                  resetWrapAroundPosition: false
	                });
	
	                _this4.props.afterSlide(endSlide);
	
	                _this4.resetAutoplay();
	              });
	            }, _this4.props.speed);
	          });
	          return;
	        }
	      }
	
	      this.props.beforeSlide(this.state.currentSlide, index);
	
	      if (index !== this.state.currentSlide) {
	        this.props.afterSlide(index);
	      }
	
	      this.setState({
	        currentSlide: index
	      }, function () {
	        _this4.resetAutoplay();
	      });
	    }
	  }, {
	    key: "nextSlide",
	    value: function nextSlide() {
	      var childrenCount = _react.default.Children.count(this.props.children);
	
	      var slidesToShow = this.props.slidesToShow;
	
	      if (this.props.slidesToScroll === 'auto') {
	        slidesToShow = this.state.slidesToScroll;
	      }
	
	      if (this.state.currentSlide >= childrenCount - slidesToShow && !this.props.wrapAround && this.props.cellAlign === 'left') {
	        return;
	      }
	
	      if (this.props.wrapAround) {
	        this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
	      } else {
	        if (this.props.slideWidth !== 1) {
	          this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
	          return;
	        }
	
	        var offset = this.state.currentSlide + this.state.slidesToScroll;
	        var nextSlideIndex = this.props.cellAlign !== 'left' ? offset : Math.min(offset, childrenCount - slidesToShow);
	        this.goToSlide(nextSlideIndex);
	      }
	    }
	  }, {
	    key: "previousSlide",
	    value: function previousSlide() {
	      if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
	        return;
	      }
	
	      if (this.props.wrapAround) {
	        this.goToSlide(this.state.currentSlide - this.state.slidesToScroll);
	      } else {
	        this.goToSlide(Math.max(0, this.state.currentSlide - this.state.slidesToScroll));
	      }
	    } // Animation
	
	  }, {
	    key: "getTargetLeft",
	    value: function getTargetLeft(touchOffset, slide) {
	      var offset;
	      var target = slide || this.state.currentSlide;
	
	      switch (this.props.cellAlign) {
	        case 'left':
	          {
	            offset = 0;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	
	        case 'center':
	          {
	            offset = (this.state.frameWidth - this.state.slideWidth) / 2;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	
	        case 'right':
	          {
	            offset = this.state.frameWidth - this.state.slideWidth;
	            offset -= this.props.cellSpacing * target;
	            break;
	          }
	      }
	
	      var left = this.state.slideWidth * target;
	      var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;
	
	      if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
	        left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
	        offset = 0;
	        offset -= this.props.cellSpacing * (this.state.slideCount - 1);
	      }
	
	      offset -= touchOffset || 0;
	      return (left - offset) * -1;
	    } // Bootstrapping
	
	  }, {
	    key: "bindEvents",
	    value: function bindEvents() {
	      if (_exenv.default.canUseDOM) {
	        addEvent(window, 'resize', this.onResize);
	        addEvent(document, 'readystatechange', this.onReadyStateChange);
	        addEvent(document, 'visibilitychange', this.onVisibilityChange);
	      }
	    }
	  }, {
	    key: "onResize",
	    value: function onResize() {
	      this.setDimensions(null, this.props.onResize);
	    }
	  }, {
	    key: "onReadyStateChange",
	    value: function onReadyStateChange() {
	      this.setDimensions();
	    }
	  }, {
	    key: "onVisibilityChange",
	    value: function onVisibilityChange() {
	      if (document.hidden) {
	        this.pauseAutoplay();
	      } else {
	        this.unpauseAutoplay();
	      }
	    }
	  }, {
	    key: "unbindEvents",
	    value: function unbindEvents() {
	      if (_exenv.default.canUseDOM) {
	        removeEvent(window, 'resize', this.onResize);
	        removeEvent(document, 'readystatechange', this.onReadyStateChange);
	      }
	    }
	  }, {
	    key: "formatChildren",
	    value: function formatChildren(children) {
	      var _this5 = this;
	
	      var positionValue = this.props.vertical ? this.state.top : this.state.left;
	      return _react.default.Children.map(children, function (child, index) {
	        return _react.default.createElement("li", {
	          className: "slider-slide",
	          style: _this5.getSlideStyles(index, positionValue),
	          key: index
	        }, child);
	      });
	    }
	  }, {
	    key: "setInitialDimensions",
	    value: function setInitialDimensions() {
	      var _this6 = this;
	
	      var slideWidth = this.props.vertical ? this.props.initialSlideHeight || 0 : this.props.initialSlideWidth || 0;
	      var slideHeight = this.props.initialSlideHeight ? this.props.initialSlideHeight * this.props.slidesToShow : 0;
	      var frameHeight = slideHeight + this.props.cellSpacing * (this.props.slidesToShow - 1);
	      this.setState({
	        slideHeight: slideHeight,
	        frameWidth: this.props.vertical ? frameHeight : '100%',
	        slideCount: _react.default.Children.count(this.props.children),
	        slideWidth: slideWidth
	      }, function () {
	        _this6.setLeft();
	      });
	    }
	  }, {
	    key: "findMaxHeightSlide",
	    value: function findMaxHeightSlide(slides) {
	      var maxHeight = 0;
	
	      for (var i = 0; i < slides.length; i++) {
	        if (slides[i].offsetHeight > maxHeight) {
	          maxHeight = slides[i].offsetHeight;
	        }
	      }
	
	      return maxHeight;
	    }
	  }, {
	    key: "getSlideHeight",
	    value: function getSlideHeight(props) {
	      var childNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var heightMode = props.heightMode,
	          vertical = props.vertical;
	      var firstSlide = childNodes[0];
	
	      if (firstSlide && heightMode === 'first') {
	        return vertical ? firstSlide.offsetHeight * props.slidesToShow : firstSlide.offsetHeight;
	      }
	
	      if (heightMode === 'max') {
	        return this.findMaxHeightSlide(childNodes);
	      }
	
	      if (props.heightMode === 'current') {
	        return childNodes[this.state.currentSlide].offsetHeight;
	      }
	
	      return 100;
	    }
	  }, {
	    key: "setDimensions",
	    value: function setDimensions(props) {
	      var _this7 = this;
	
	      var stateCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	      props = props || this.props;
	      var slideWidth;
	      var slidesToScroll;
	      var frame = this.frame;
	      var childNodes = this.getChildNodes();
	      var slideHeight = this.getSlideHeight(props, childNodes);
	      slidesToScroll = props.slidesToScroll;
	
	      if (typeof props.slideWidth !== 'number') {
	        slideWidth = parseInt(props.slideWidth);
	      } else if (props.vertical) {
	        slideWidth = slideHeight / props.slidesToShow * props.slideWidth;
	      } else {
	        slideWidth = frame.offsetWidth / props.slidesToShow * props.slideWidth;
	      }
	
	      if (!props.vertical) {
	        slideWidth -= props.cellSpacing * ((100 - 100 / props.slidesToShow) / 100);
	      }
	
	      var frameHeight = slideHeight + props.cellSpacing * (props.slidesToShow - 1);
	      var frameWidth = props.vertical ? frameHeight : frame.offsetWidth;
	
	      if (props.slidesToScroll === 'auto') {
	        slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
	      }
	
	      this.setState({
	        slideHeight: slideHeight,
	        frameWidth: frameWidth,
	        slideWidth: slideWidth,
	        slidesToScroll: slidesToScroll,
	        left: props.vertical ? 0 : this.getTargetLeft(),
	        top: props.vertical ? this.getTargetLeft() : 0
	      }, function () {
	        stateCb();
	
	        _this7.setLeft();
	      });
	    }
	  }, {
	    key: "getChildNodes",
	    value: function getChildNodes() {
	      return this.frame.childNodes[0].childNodes;
	    }
	  }, {
	    key: "setLeft",
	    value: function setLeft() {
	      this.setState({
	        left: this.props.vertical ? 0 : this.getTargetLeft(),
	        top: this.props.vertical ? this.getTargetLeft() : 0
	      });
	    } // Styles
	
	  }, {
	    key: "getListStyles",
	    value: function getListStyles(styles) {
	      var tx = styles.tx,
	          ty = styles.ty;
	
	      var listWidth = this.state.slideWidth * _react.default.Children.count(this.props.children);
	
	      var spacingOffset = this.props.cellSpacing * _react.default.Children.count(this.props.children);
	
	      var transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0)");
	      return {
	        transform: transform,
	        WebkitTransform: transform,
	        msTransform: "translate(".concat(tx, "px, ").concat(ty, "px)"),
	        position: 'relative',
	        display: 'block',
	        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
	        padding: 0,
	        height: this.props.vertical ? listWidth + spacingOffset : this.state.slideHeight,
	        width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
	        cursor: this.state.dragging === true ? 'pointer' : 'inherit',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box'
	      };
	    }
	  }, {
	    key: "getFrameStyles",
	    value: function getFrameStyles() {
	      return {
	        position: 'relative',
	        display: 'block',
	        overflow: this.props.frameOverflow,
	        height: this.props.vertical ? this.state.frameWidth || 'initial' : 'auto',
	        margin: this.props.framePadding,
	        padding: 0,
	        transform: 'translate3d(0, 0, 0)',
	        WebkitTransform: 'translate3d(0, 0, 0)',
	        msTransform: 'translate(0, 0)',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box',
	        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y')
	      };
	    }
	  }, {
	    key: "getSlideStyles",
	    value: function getSlideStyles(index, positionValue) {
	      var targetPosition = this.getSlideTargetPosition(index, positionValue);
	      return {
	        position: 'absolute',
	        left: this.props.vertical ? 0 : targetPosition,
	        top: this.props.vertical ? targetPosition : 0,
	        display: this.props.vertical ? 'block' : 'inline-block',
	        listStyleType: 'none',
	        verticalAlign: 'top',
	        width: this.props.vertical ? '100%' : this.state.slideWidth,
	        height: 'auto',
	        minHeight: '100%',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box',
	        marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
	        marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
	        marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto'
	      };
	    }
	  }, {
	    key: "getSlideTargetPosition",
	    value: function getSlideTargetPosition(index, positionValue) {
	      var slidesToShow = this.state.frameWidth / this.state.slideWidth;
	      var targetPosition = (this.state.slideWidth + this.props.cellSpacing) * index;
	      var end = (this.state.slideWidth + this.props.cellSpacing) * slidesToShow * -1;
	
	      if (this.props.wrapAround && (this.state.isWrappingAround || this.state.dragging)) {
	        var slidesBefore = Math.ceil(positionValue / this.state.slideWidth);
	
	        if (this.state.slideCount - slidesBefore <= index) {
	          return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount - index) * -1;
	        }
	
	        var slidesAfter = Math.ceil((Math.abs(positionValue) - Math.abs(end)) / this.state.slideWidth);
	
	        if (this.state.slideWidth !== 1) {
	          slidesAfter = Math.ceil((Math.abs(positionValue) - this.state.slideWidth) / this.state.slideWidth);
	        }
	
	        if (index <= slidesAfter - 1) {
	          return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount + index);
	        }
	      }
	
	      return targetPosition;
	    }
	  }, {
	    key: "getSliderStyles",
	    value: function getSliderStyles() {
	      return {
	        position: 'relative',
	        display: 'block',
	        width: this.props.width,
	        height: 'auto',
	        boxSizing: 'border-box',
	        MozBoxSizing: 'border-box',
	        visibility: this.state.slideWidth ? 'visible' : 'hidden'
	      };
	    }
	  }, {
	    key: "getStyleTagStyles",
	    value: function getStyleTagStyles() {
	      return '.slider-slide > img {width: 100%; display: block;}';
	    }
	  }, {
	    key: "getDecoratorStyles",
	    value: function getDecoratorStyles(position) {
	      switch (position) {
	        case 'TopLeft':
	          {
	            return {
	              position: 'absolute',
	              top: 0,
	              left: 0
	            };
	          }
	
	        case 'TopCenter':
	          {
	            return {
	              position: 'absolute',
	              top: 0,
	              left: '50%',
	              transform: 'translateX(-50%)',
	              WebkitTransform: 'translateX(-50%)',
	              msTransform: 'translateX(-50%)'
	            };
	          }
	
	        case 'TopRight':
	          {
	            return {
	              position: 'absolute',
	              top: 0,
	              right: 0
	            };
	          }
	
	        case 'CenterLeft':
	          {
	            return {
	              position: 'absolute',
	              top: '50%',
	              left: 0,
	              transform: 'translateY(-50%)',
	              WebkitTransform: 'translateY(-50%)',
	              msTransform: 'translateY(-50%)'
	            };
	          }
	
	        case 'CenterCenter':
	          {
	            return {
	              position: 'absolute',
	              top: '50%',
	              left: '50%',
	              transform: 'translate(-50%,-50%)',
	              WebkitTransform: 'translate(-50%, -50%)',
	              msTransform: 'translate(-50%, -50%)'
	            };
	          }
	
	        case 'CenterRight':
	          {
	            return {
	              position: 'absolute',
	              top: '50%',
	              right: 0,
	              transform: 'translateY(-50%)',
	              WebkitTransform: 'translateY(-50%)',
	              msTransform: 'translateY(-50%)'
	            };
	          }
	
	        case 'BottomLeft':
	          {
	            return {
	              position: 'absolute',
	              bottom: 0,
	              left: 0
	            };
	          }
	
	        case 'BottomCenter':
	          {
	            return {
	              position: 'absolute',
	              bottom: 0,
	              left: '50%',
	              transform: 'translateX(-50%)',
	              WebkitTransform: 'translateX(-50%)',
	              msTransform: 'translateX(-50%)'
	            };
	          }
	
	        case 'BottomRight':
	          {
	            return {
	              position: 'absolute',
	              bottom: 0,
	              right: 0
	            };
	          }
	
	        default:
	          {
	            return {
	              position: 'absolute',
	              top: 0,
	              left: 0
	            };
	          }
	      }
	    }
	  }, {
	    key: "getOffsetDeltas",
	    value: function getOffsetDeltas() {
	      var offset = 0;
	
	      if (this.state.isWrappingAround) {
	        offset = this.getTargetLeft(null, this.state.wrapToIndex);
	      } else {
	        offset = this.getTargetLeft(this.touchObject.length * this.touchObject.direction);
	      }
	
	      return {
	        tx: [this.props.vertical ? 0 : offset],
	        ty: [this.props.vertical ? offset : 0]
	      };
	    }
	  }, {
	    key: "renderControls",
	    value: function renderControls() {
	      var _this8 = this;
	
	      return this.controlsMap.map(function (_ref) {
	        var func = _ref.func,
	            key = _ref.key;
	        return func && typeof func === 'function' && _react.default.createElement("div", {
	          className: "slider-control-".concat(key.toLowerCase()),
	          style: _this8.getDecoratorStyles(key),
	          key: key
	        }, func({
	          currentSlide: _this8.state.currentSlide,
	          slideCount: _this8.state.slideCount,
	          frameWidth: _this8.state.frameWidth,
	          slideWidth: _this8.state.slideWidth,
	          slidesToScroll: _this8.state.slidesToScroll,
	          cellSpacing: _this8.props.cellSpacing,
	          slidesToShow: _this8.props.slidesToShow,
	          wrapAround: _this8.props.wrapAround,
	          nextSlide: function nextSlide() {
	            return _this8.nextSlide();
	          },
	          previousSlide: function previousSlide() {
	            return _this8.previousSlide();
	          },
	          goToSlide: function goToSlide(index) {
	            return _this8.goToSlide(index);
	          }
	        }));
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this9 = this;
	
	      var _children = this.formatChildren(this.props.children);
	
	      var duration = this.state.dragging || this.state.resetWrapAroundPosition ? 0 : this.props.speed;
	      var frameStyles = this.getFrameStyles();
	      var touchEvents = this.getTouchEvents();
	      var mouseEvents = this.getMouseEvents();
	      return _react.default.createElement("div", {
	        className: ['slider', this.props.className || ''].join(' '),
	        style: _extends({}, this.getSliderStyles(), this.props.style)
	      }, _react.default.createElement(_Animate.default, {
	        show: true,
	        start: {
	          tx: 0,
	          ty: 0
	        },
	        update: _extends({}, this.getOffsetDeltas(), {
	          timing: {
	            duration: duration,
	            ease: this.state.easing
	          }
	        }),
	        children: function children(_ref2) {
	          var tx = _ref2.tx,
	              ty = _ref2.ty;
	          return _react.default.createElement("div", _extends({
	            className: "slider-frame",
	            ref: function ref(frame) {
	              return _this9.frame = frame;
	            },
	            style: frameStyles
	          }, touchEvents, mouseEvents, {
	            onClick: _this9.handleClick
	          }), _react.default.createElement("ul", {
	            className: "slider-list",
	            style: _this9.getListStyles({
	              tx: tx,
	              ty: ty
	            })
	          }, _children));
	        }
	      }), this.renderControls(), _react.default.createElement("style", {
	        type: "text/css",
	        dangerouslySetInnerHTML: {
	          __html: this.getStyleTagStyles()
	        }
	      }));
	    }
	  }]);
	
	  return Carousel;
	}(_react.default.Component);
	
	exports.default = Carousel;
	Carousel.propTypes = {
	  afterSlide: _propTypes.default.func,
	  autoplay: _propTypes.default.bool,
	  autoplayInterval: _propTypes.default.number,
	  beforeSlide: _propTypes.default.func,
	  cellAlign: _propTypes.default.oneOf(['left', 'center', 'right']),
	  cellSpacing: _propTypes.default.number,
	  dragging: _propTypes.default.bool,
	  easing: _propTypes.default.string,
	  edgeEasing: _propTypes.default.string,
	  frameOverflow: _propTypes.default.string,
	  framePadding: _propTypes.default.string,
	  heightMode: _propTypes.default.oneOf(['first', 'current', 'max']),
	  initialSlideHeight: _propTypes.default.number,
	  initialSlideWidth: _propTypes.default.number,
	  onResize: _propTypes.default.func,
	  renderTopLeftControls: _propTypes.default.func,
	  renderTopCenterControls: _propTypes.default.func,
	  renderTopRightControls: _propTypes.default.func,
	  renderCenterLeftControls: _propTypes.default.func,
	  renderCenterCenterControls: _propTypes.default.func,
	  renderCenterRightControls: _propTypes.default.func,
	  renderBottomLeftControls: _propTypes.default.func,
	  renderBottomCenterControls: _propTypes.default.func,
	  renderBottomRightControls: _propTypes.default.func,
	  slideIndex: _propTypes.default.number,
	  slidesToScroll: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
	  slidesToShow: _propTypes.default.number,
	  slideWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  speed: _propTypes.default.number,
	  swiping: _propTypes.default.bool,
	  vertical: _propTypes.default.bool,
	  width: _propTypes.default.string,
	  wrapAround: _propTypes.default.bool
	};
	Carousel.defaultProps = {
	  afterSlide: function afterSlide() {},
	  autoplay: false,
	  autoplayInterval: 3000,
	  beforeSlide: function beforeSlide() {},
	  cellAlign: 'left',
	  cellSpacing: 0,
	  dragging: true,
	  easing: 'easeCircleOut',
	  edgeEasing: 'easeElasticOut',
	  framePadding: '0px',
	  frameOverflow: 'hidden',
	  heightMode: 'first',
	  onResize: function onResize() {},
	  slideIndex: 0,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  style: {},
	  renderCenterLeftControls: function renderCenterLeftControls(props) {
	    return _react.default.createElement(_defaultControls.PreviousButton, props);
	  },
	  renderCenterRightControls: function renderCenterRightControls(props) {
	    return _react.default.createElement(_defaultControls.NextButton, props);
	  },
	  renderBottomCenterControls: function renderBottomCenterControls(props) {
	    return _react.default.createElement(_defaultControls.PagingDots, props);
	  },
	  slideWidth: 1,
	  speed: 500,
	  swiping: true,
	  vertical: false,
	  width: '100%',
	  wrapAround: false
	};

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFacebook = function FaFacebook(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.4 0.3v5.9h-3.5q-1.9 0-2.6 0.8t-0.7 2.4v4.2h6.6l-0.9 6.6h-5.7v16.9h-6.8v-16.9h-5.7v-6.6h5.7v-4.9q0-4.1 2.3-6.4t6.2-2.3q3.3 0 5.1 0.3z' })
	        )
	    );
	};
	
	exports.default = FaFacebook;
	module.exports = exports['default'];

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGooglePlus = function FaGooglePlus(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.2 20.3q0 3.6-1.6 6.5t-4.3 4.4-6.5 1.6q-2.6 0-5-1t-4.1-2.7-2.7-4.1-1-5 1-5 2.7-4.1 4.1-2.7 5-1q5 0 8.6 3.3l-3.5 3.4q-2-2-5.1-2-2.1 0-4 1.1t-2.8 2.9-1.1 4.1 1.1 4.1 2.8 2.9 4 1.1q1.5 0 2.7-0.4t2-1 1.4-1.4 0.8-1.4 0.4-1.3h-7.3v-4.4h12.1q0.3 1.1 0.3 2.1z m15.1-2.1v3.6h-3.6v3.7h-3.7v-3.7h-3.7v-3.6h3.7v-3.7h3.7v3.7h3.6z' })
	        )
	    );
	};
	
	exports.default = FaGooglePlus;
	module.exports = exports['default'];

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPinterestP = function FaPinterestP(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5.5 13.3q0-2.4 0.8-4.5t2.3-3.7 3.4-2.8 4.2-1.7 4.5-0.6q3.5 0 6.5 1.5t5 4.3 1.9 6.4q0 2.2-0.5 4.2t-1.3 4-2.2 3.3-3.3 2.3-4.2 0.9q-1.5 0-3-0.8t-2.1-1.9q-0.3 0.8-0.7 2.5t-0.5 2.1-0.4 1.6-0.6 1.6-0.7 1.4-1.1 1.7-1.4 1.9l-0.3 0.1-0.2-0.2q-0.3-3.5-0.3-4.2 0-2 0.5-4.6t1.5-6.4 1.1-4.5q-0.7-1.5-0.7-3.8 0-1.9 1.2-3.5t2.9-1.6q1.4 0 2.1 0.9t0.8 2.3q0 1.5-1 4.2t-1 4.2q0 1.4 1 2.3t2.5 1q1.2 0 2.3-0.6t1.7-1.5 1.3-2.1 0.8-2.5 0.4-2.5 0.2-2.2q0-3.9-2.5-6t-6.3-2.2q-4.5 0-7.5 2.9t-3 7.4q0 0.9 0.3 1.9t0.6 1.4 0.6 1 0.3 0.7q0 0.6-0.3 1.6t-0.9 1q0 0-0.3 0-1.2-0.4-2.1-1.3t-1.3-2.1-0.8-2.4-0.2-2.4z' })
	        )
	    );
	};
	
	exports.default = FaPinterestP;
	module.exports = exports['default'];

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTwitter = function FaTwitter(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.7 9.1q-1.5 2.2-3.7 3.7 0.1 0.3 0.1 1 0 2.9-0.9 5.8t-2.6 5.5-4.1 4.7-5.7 3.3-7.2 1.2q-6.1 0-11.1-3.3 0.8 0.1 1.7 0.1 5 0 9-3-2.4-0.1-4.2-1.5t-2.6-3.5q0.8 0.1 1.4 0.1 1 0 1.9-0.3-2.5-0.5-4.1-2.5t-1.7-4.6v0q1.5 0.8 3.3 0.9-1.5-1-2.4-2.6t-0.8-3.4q0-2 0.9-3.7 2.7 3.4 6.6 5.4t8.3 2.2q-0.2-0.9-0.2-1.7 0-3 2.1-5.1t5.1-2.1q3.2 0 5.3 2.3 2.4-0.5 4.6-1.7-0.8 2.5-3.2 3.9 2.1-0.2 4.2-1.1z' })
	        )
	    );
	};
	
	exports.default = FaTwitter;
	module.exports = exports['default'];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IoAndroidCheckmarkCircle = function IoAndroidCheckmarkCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.1 16.9l5 5 14-13.9 2.3 2.2-16.3 16.3-7.3-7.3z m19.6 3.1h3.3c0 8.9-7.3 16.3-16.2 16.3s-16.3-7.4-16.3-16.3 7.3-16.2 16.3-16.2c2.1 0 4.2 0.4 6 1.2l-2.5 2.5c-1.1-0.3-2.3-0.5-3.5-0.5-7.2 0-13 5.8-13 13s5.8 13 13 13 12.9-5.8 12.9-13z' })
	        )
	    );
	};
	
	exports.default = IoAndroidCheckmarkCircle;
	module.exports = exports['default'];

/***/ }),

/***/ 4055:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IoIosCircleFilled = function IoIosCircleFilled(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.8 3.8c8.9 0 16.2 7.2 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.3-16.3-16.3 7.3-16.2 16.3-16.2z m0 31.1c8.2 0 14.9-6.7 14.9-14.9s-6.7-14.9-14.9-14.9-15 6.7-15 14.9 6.7 14.9 15 14.9z m0-27.4c6.8 0 12.5 5.6 12.5 12.5s-5.7 12.5-12.5 12.5-12.5-5.6-12.5-12.5 5.6-12.5 12.5-12.5z' })
	        )
	    );
	};
	
	exports.default = IoIosCircleFilled;
	module.exports = exports['default'];

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IoSocialInstagram = function IoSocialInstagram(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.8 20c0-4.1 2.1-6.2 6.2-6.2s6.3 2.1 6.3 6.2-2.2 6.3-6.3 6.3-6.2-2.2-6.2-6.3z m0-6.2c-1.1 1.1-1.8 2.3-2.2 3.7h-6.6v-8.7c0-1.1 0.3-2 1.1-2.7s1.7-1.1 2.7-1.1h22.5c1 0 1.9 0.4 2.6 1.1s1.1 1.6 1.1 2.7v8.7h-6.6c-0.4-1.4-1.1-2.6-2.2-3.7-1.7-1.7-3.8-2.5-6.2-2.5s-4.5 0.8-6.2 2.5z m18.7-2.2v-3.1c0-0.3-0.2-0.5-0.3-0.7s-0.4-0.3-0.7-0.3h-3c-0.3 0-0.5 0.2-0.7 0.3s-0.3 0.4-0.3 0.7v3.1c0 0.3 0.2 0.5 0.3 0.7s0.4 0.2 0.7 0.2h3c0.3 0 0.5-0.1 0.7-0.2s0.3-0.4 0.3-0.7z m-6.2 14.6c1.7-1.7 2.5-3.8 2.5-6.2h6.2v11.3c0 1-0.4 1.8-1.1 2.6s-1.6 1.1-2.6 1.1h-22.5c-1 0-1.8-0.3-2.6-1.1s-1.2-1.6-1.2-2.6v-11.3h6.3c0 2.4 0.8 4.5 2.5 6.2s3.8 2.6 6.2 2.6 4.5-0.9 6.3-2.6z' })
	        )
	    );
	};
	
	exports.default = IoSocialInstagram;
	module.exports = exports['default'];

/***/ }),

/***/ 4058:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdChevronLeft = function MdChevronLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.7 12.3l-7.7 7.7 7.7 7.7-2.3 2.3-10-10 10-10z' })
	        )
	    );
	};
	
	exports.default = MdChevronLeft;
	module.exports = exports['default'];

/***/ }),

/***/ 4059:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdChevronRight = function MdChevronRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm16.6 10l10 10-10 10-2.3-2.3 7.7-7.7-7.7-7.7z' })
	        )
	    );
	};
	
	exports.default = MdChevronRight;
	module.exports = exports['default'];

/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(21);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MdErrorOutline = function MdErrorOutline(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20 33.4c7.3 0 13.4-6.1 13.4-13.4s-6.1-13.4-13.4-13.4-13.4 6.1-13.4 13.4 6.1 13.4 13.4 13.4z m0-30c9.2 0 16.6 7.4 16.6 16.6s-7.4 16.6-16.6 16.6-16.6-7.4-16.6-16.6 7.4-16.6 16.6-16.6z m-1.6 8.2h3.2v10h-3.2v-10z m0 13.4h3.2v3.4h-3.2v-3.4z' })
	        )
	    );
	};
	
	exports.default = MdErrorOutline;
	module.exports = exports['default'];

/***/ }),

/***/ 4066:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Timer = __webpack_require__(587);
	
	var _transition = __webpack_require__(4068);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  weak
	/* eslint max-len: "off" */
	
	var Animate = function (_Component) {
	  _inherits(Animate, _Component);
	
	  function Animate() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Animate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = typeof _this.props.start === 'function' ? _this.props.start() : _this.props.start, _this.checkTransitionStatus = function () {
	      if (!_this.TRANSITION_SCHEDULES) {
	        _this.interval.stop();
	
	        if (_this.props.show === false) {
	          _this.renderNull = true;
	          _this.setState(function (prevState) {
	            return prevState;
	          }); // force render as null
	        }
	      }
	    }, _this.interval = null, _this.renderNull = true, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Animate.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.show === true) {
	      this.renderNull = false;
	    }
	  };
	
	  Animate.prototype.componentDidMount = function componentDidMount() {
	    var _props = this.props,
	        enter = _props.enter,
	        show = _props.show;
	
	
	    if (enter && show === true) {
	      _transition.transition.call(this, typeof enter === 'function' ? enter() : enter);
	    }
	  };
	
	  Animate.prototype.componentWillReceiveProps = function componentWillReceiveProps(next) {
	    var _this2 = this;
	
	    var show = next.show,
	        start = next.start,
	        enter = next.enter,
	        update = next.update,
	        leave = next.leave;
	
	
	    if (this.props.show === false && this.renderNull === true && show === true) {
	      this.renderNull = false;
	
	      this.setState(function () {
	        return typeof start === 'function' ? start() : start;
	      }, function () {
	        if (enter) {
	          _transition.transition.call(_this2, typeof enter === 'function' ? enter() : enter);
	        }
	      });
	    } else if (this.props.show === true && show === false) {
	      if (leave) {
	        _transition.transition.call(this, typeof leave === 'function' ? leave() : leave);
	        this.interval = (0, _d3Timer.interval)(this.checkTransitionStatus);
	      } else {
	        this.renderNull = true;
	        this.setState(function (prevState) {
	          return prevState;
	        }); // force render as null
	      }
	    } else if (show === true && update) {
	      if (this.interval) {
	        this.interval.stop();
	      }
	
	      _transition.transition.call(this, typeof update === 'function' ? update() : update);
	    }
	  };
	
	  Animate.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.interval) {
	      this.interval.stop();
	    }
	
	    _transition.stop.call(this);
	  };
	
	  Animate.prototype.render = function render() {
	    if (this.renderNull === true) {
	      return null;
	    }
	
	    var renderedChildren = this.props.children(this.state);
	    return renderedChildren && _react2.default.Children.only(renderedChildren);
	  };
	
	  return Animate;
	}(_react.Component);
	
	Animate.defaultProps = {
	  show: true
	};
	exports.default = Animate;

/***/ }),

/***/ 4067:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _Animate = __webpack_require__(4066);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Animate2.default; /* eslint-disable flowtype/require-valid-file-annotation */

/***/ }),

/***/ 4068:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _transition = __webpack_require__(4071);
	
	Object.defineProperty(exports, 'transition', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_transition).default;
	  }
	});
	
	var _stop = __webpack_require__(4070);
	
	Object.defineProperty(exports, 'stop', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stop).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 4069:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //  weak
	/* eslint no-use-before-define: "off" */
	// Apapted from https://github.com/d3/d3-transition/blob/master/src/transition/schedule.js
	
	exports.default = function (node, stateKey, id, timing, tweens) {
	  var events = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	  var schedules = node.TRANSITION_SCHEDULES;
	  if (!schedules) {
	    node.TRANSITION_SCHEDULES = {}; // eslint-disable-line no-param-reassign
	  } else if (id in schedules) {
	    return;
	  }
	
	  var config = _extends({ stateKey: stateKey, events: events, tweens: tweens }, timing, { timer: null, state: CREATED });
	  create(node, id, config);
	};
	
	var _d3Timer = __webpack_require__(587);
	
	var CREATED = 0;
	var SCHEDULED = 1;
	var STARTING = 2;
	var STARTED = 3;
	var RUNNING = 4;
	var ENDING = 5;
	var ENDED = 6;
	
	function create(node, id, config) {
	  var schedules = node.TRANSITION_SCHEDULES;
	
	  // Initialize the transition timer when the transition is created.
	  // Note the actual delay is not known until the first callback!
	  var transition = _extends({}, config);
	  var n = transition.tweens.length;
	  var tweens = new Array(n);
	
	  schedules[id] = transition;
	  transition.timer = (0, _d3Timer.timer)(schedule, 0, transition.time);
	
	  function schedule(elapsed) {
	    transition.state = SCHEDULED;
	    transition.timer.restart(start, transition.delay, transition.time);
	
	    // If the elapsed delay is less than our first sleep, start immediately.
	    if (transition.delay <= elapsed) {
	      start(elapsed - transition.delay);
	    }
	  }
	
	  function start(elapsed) {
	    // eslint-disable-line consistent-return
	    // If the state is not SCHEDULED, then we previously errored on start.
	    if (transition.state !== SCHEDULED) return stop();
	
	    for (var sid in schedules) {
	      // eslint-disable-line
	      var s = schedules[sid];
	
	      if (s.stateKey !== transition.stateKey) {
	        continue; // eslint-disable-line no-continue
	      }
	
	      // While this element already has a starting transition during this frame,
	      // defer starting an interrupting transition until that transition has a
	      // chance to tick (and possibly end); see d3/d3-transition#54!
	      if (s.state === STARTED) return (0, _d3Timer.timeout)(start);
	
	      // 1. Interrupt the active transition, if any. dispatch the interrupt event.
	      // 2. Cancel any pre-empted transitions. No interrupt event is dispatched
	      // because the cancelled transitions never started. Note that this also
	      // removes this transition from the pending list!
	
	      if (s.state === RUNNING) {
	        s.state = ENDED;
	        s.timer.stop();
	        if (s.events.interrupt && typeof s.events.interrupt === 'function') {
	          s.events.interrupt.call(this);
	        }
	        delete schedules[sid];
	      } else if (+sid < id) {
	        s.state = ENDED;
	        s.timer.stop();
	        delete schedules[sid];
	      }
	    }
	
	    // Defer the first tick to end of the current frame; see d3/d3#1576.
	    // Note the transition may be canceled after start and before the first tick!
	    // Note this must be scheduled before the start event; see d3/d3-transition#16!
	    // Assuming this is successful, subsequent callbacks go straight to tick.
	    (0, _d3Timer.timeout)(function () {
	      if (transition.state === STARTED) {
	        transition.state = RUNNING;
	        transition.timer.restart(tick, transition.delay, transition.time);
	        tick(elapsed);
	      }
	    });
	
	    transition.state = STARTING;
	    if (transition.events.start && typeof transition.events.start === 'function') {
	      transition.events.start.call(node);
	    }
	
	    if (transition.state !== STARTING) {
	      // interrupted
	      return; // eslint-disable-line consistent-return
	    }
	
	    transition.state = STARTED;
	
	    // Initialize the tween, deleting null tween.
	    var j = -1;
	
	    for (var i = 0; i < n; ++i) {
	      var res = transition.tweens[i].call(node);
	
	      if (res) {
	        tweens[++j] = res;
	      }
	    }
	
	    tweens.length = j + 1;
	  }
	
	  function tick(elapsed) {
	    var t = 1;
	
	    if (elapsed < transition.duration) {
	      t = transition.ease.call(null, elapsed / transition.duration);
	    } else {
	      transition.timer.restart(stop);
	      transition.state = ENDING;
	    }
	
	    var i = -1;
	
	    while (++i < tweens.length) {
	      tweens[i].call(null, t);
	    }
	
	    if (transition.state === ENDING) {
	      if (transition.events.end && typeof transition.events.end === 'function') {
	        transition.events.end.call(node);
	      }
	      stop();
	    }
	  }
	
	  function stop() {
	    transition.state = ENDED;
	    transition.timer.stop();
	
	    delete schedules[id];
	    for (var i in schedules) {
	      return;
	    } // eslint-disable-line guard-for-in, no-restricted-syntax
	    delete node.TRANSITION_SCHEDULES; // eslint-disable-line no-param-reassign
	  }
	}

/***/ }),

/***/ 4070:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = stop;
	//  weak
	
	function stop() {
	  var ts = this.TRANSITION_SCHEDULES;
	
	  if (ts) {
	    Object.keys(ts).forEach(function (s) {
	      ts[s].timer.stop();
	    });
	  }
	}

/***/ }),

/***/ 4071:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.preset = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //  weak
	
	exports.newId = newId;
	exports.default = transition;
	
	var _d3Timer = __webpack_require__(587);
	
	var _tween = __webpack_require__(4072);
	
	var _tween2 = _interopRequireDefault(_tween);
	
	var _schedule = __webpack_require__(4069);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function once(func) {
	  var called = false;
	
	  return function transitionEvent() {
	    if (!called) {
	      called = true;
	      func.call(this);
	    }
	  };
	}
	
	var id = 0;
	
	function newId() {
	  return ++id;
	}
	
	// from https://github.com/d3/d3-ease/blob/master/src/linear.js
	function linear(t) {
	  return +t;
	}
	
	var preset = exports.preset = {
	  time: null,
	  delay: 0,
	  duration: 250,
	  ease: linear
	};
	
	function scheduleTransitions() {
	  var _this = this;
	
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var transitions = _extends({}, config);
	
	  var events = transitions.events || {};
	  delete transitions.events;
	
	  // each event handler should be called only once
	  Object.keys(events).forEach(function (d) {
	    if (typeof events[d] !== 'function') {
	      throw new Error('Event handlers must be a function');
	    } else {
	      events[d] = once(events[d]);
	    }
	  });
	
	  var timing = transitions.timing || {};
	  delete transitions.timing;
	
	  Object.keys(transitions).forEach(function (stateKey) {
	    var tweens = [];
	
	    if (_typeof(transitions[stateKey]) === 'object' && Array.isArray(transitions[stateKey]) === false) {
	      Object.keys(transitions[stateKey]).forEach(function (attr) {
	        var val = transitions[stateKey][attr];
	
	        if (Array.isArray(val)) {
	          if (val.length === 1) {
	            tweens.push(_tween2.default.call(_this, stateKey, attr, val[0]));
	          } else {
	            _this.setState(function (state) {
	              var _extends2, _ref;
	
	              return _ref = {}, _ref[stateKey] = _extends({}, state[stateKey], (_extends2 = {}, _extends2[attr] = val[0], _extends2)), _ref;
	            });
	
	            tweens.push(_tween2.default.call(_this, stateKey, attr, val[1]));
	          }
	        } else if (typeof val === 'function') {
	          var getResonanceCustomTween = function getResonanceCustomTween() {
	            var resonanceCustomTween = function resonanceCustomTween(t) {
	              _this.setState(function (state) {
	                var _extends3, _ref2;
	
	                return _ref2 = {}, _ref2[stateKey] = _extends({}, state[stateKey], (_extends3 = {}, _extends3[attr] = val(t), _extends3)), _ref2;
	              });
	            };
	
	            return resonanceCustomTween;
	          };
	
	          tweens.push(getResonanceCustomTween);
	        } else {
	          _this.setState(function (state) {
	            var _extends4, _ref3;
	
	            return _ref3 = {}, _ref3[stateKey] = _extends({}, state[stateKey], (_extends4 = {}, _extends4[attr] = val, _extends4)), _ref3;
	          });
	          // This assures any existing transitions are stopped
	          tweens.push(_tween2.default.call(_this, stateKey, attr, val));
	        }
	      });
	    } else {
	      var val = transitions[stateKey];
	
	      if (Array.isArray(val)) {
	        if (val.length === 1) {
	          tweens.push(_tween2.default.call(_this, null, stateKey, val[0]));
	        } else {
	          _this.setState(function () {
	            var _ref4;
	
	            return _ref4 = {}, _ref4[stateKey] = val[0], _ref4;
	          });
	
	          tweens.push(_tween2.default.call(_this, null, stateKey, val[1]));
	        }
	      } else if (typeof val === 'function') {
	        var getResonanceCustomTween = function getResonanceCustomTween() {
	          var resonanceCustomTween = function resonanceCustomTween(t) {
	            _this.setState(function () {
	              var _ref5;
	
	              return _ref5 = {}, _ref5[stateKey] = val(t), _ref5;
	            });
	          };
	
	          return resonanceCustomTween;
	        };
	
	        tweens.push(getResonanceCustomTween);
	      } else {
	        _this.setState(function () {
	          var _ref6;
	
	          return _ref6 = {}, _ref6[stateKey] = val, _ref6;
	        });
	        // This assures any existing transitions are stopped
	        tweens.push(_tween2.default.call(_this, null, stateKey, val));
	      }
	    }
	
	    var timingConfig = _extends({}, preset, timing, { time: (0, _d3Timer.now)() });
	    (0, _schedule2.default)(_this, stateKey, newId(), timingConfig, tweens, events);
	  });
	}
	
	function transition(config) {
	  var _this2 = this;
	
	  if (Array.isArray(config)) {
	    config.forEach(function (c) {
	      scheduleTransitions.call(_this2, c);
	    });
	  } else {
	    scheduleTransitions.call(this, config);
	  }
	}

/***/ }),

/***/ 4072:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //  weak
	
	
	exports.getInterpolator = getInterpolator;
	
	exports.default = function (nameSpace, attr, value) {
	  return getTween.call(this, nameSpace, attr, value);
	};
	
	var _d3Interpolate = __webpack_require__(1049);
	
	function getInterpolator(attr) {
	  if (attr === 'transform') {
	    return _d3Interpolate.interpolateTransformSvg;
	  }
	
	  return _d3Interpolate.interpolate;
	}
	
	function getTween(nameSpace, attr, value1) {
	  return function tween() {
	    var _this = this;
	
	    var value0 = nameSpace ? this.state[nameSpace][attr] : this.state[attr];
	
	    if (value0 === value1) {
	      return null;
	    }
	
	    var i = getInterpolator(attr)(value0, value1);
	
	    var stateTween = void 0;
	
	    if (nameSpace === null) {
	      stateTween = function stateTween(t) {
	        _this.setState(function () {
	          var _ref;
	
	          return _ref = {}, _ref[attr] = i(t), _ref;
	        });
	      };
	    } else {
	      stateTween = function stateTween(t) {
	        _this.setState(function (state) {
	          var _extends2, _ref2;
	
	          return _ref2 = {}, _ref2[nameSpace] = _extends({}, state[nameSpace], (_extends2 = {}, _extends2[attr] = i(t), _extends2)), _ref2;
	        });
	      };
	    }
	
	    return stateTween;
	  };
	}

/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.genericHashLink = genericHashLink;
	exports.HashLink = HashLink;
	exports.NavHashLink = NavHashLink;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouterDom = __webpack_require__(229);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hashFragment = '';
	var observer = null;
	var asyncTimerId = null;
	var scrollFunction = null;
	
	function reset() {
	  hashFragment = '';
	  if (observer !== null) observer.disconnect();
	  if (asyncTimerId !== null) {
	    window.clearTimeout(asyncTimerId);
	    asyncTimerId = null;
	  }
	}
	
	function getElAndScroll() {
	  var element = document.getElementById(hashFragment);
	  if (element !== null) {
	    scrollFunction(element);
	    reset();
	    return true;
	  }
	  return false;
	}
	
	function hashLinkScroll() {
	  // Push onto callback queue so it runs after the DOM is updated
	  window.setTimeout(function () {
	    if (getElAndScroll() === false) {
	      if (observer === null) {
	        observer = new MutationObserver(getElAndScroll);
	      }
	      observer.observe(document, {
	        attributes: true,
	        childList: true,
	        subtree: true
	      });
	      // if the element doesn't show up in 10 seconds, stop checking
	      asyncTimerId = window.setTimeout(function () {
	        reset();
	      }, 10000);
	    }
	  }, 0);
	}
	
	function genericHashLink(props, As) {
	  function handleClick(e) {
	    reset();
	    if (props.onClick) props.onClick(e);
	    if (typeof props.to === 'string') {
	      hashFragment = props.to.split('#').slice(1).join('#');
	    } else if (_typeof(props.to) === 'object' && typeof props.to.hash === 'string') {
	      hashFragment = props.to.hash.replace('#', '');
	    }
	    if (hashFragment !== '') {
	      scrollFunction = props.scroll || function (el) {
	        return el.scrollIntoView(props.smooth ? { behavior: 'smooth' } : undefined);
	      };
	      hashLinkScroll();
	    }
	  }
	
	  var scroll = props.scroll,
	      smooth = props.smooth,
	      filteredProps = _objectWithoutProperties(props, ['scroll', 'smooth']);
	
	  return _react2.default.createElement(
	    As,
	    _extends({}, filteredProps, { onClick: handleClick }),
	    props.children
	  );
	}
	
	function HashLink(props) {
	  return genericHashLink(props, _reactRouterDom.Link);
	}
	
	function NavHashLink(props) {
	  return genericHashLink(props, _reactRouterDom.NavLink);
	}
	
	var propTypes = {
	  onClick: _propTypes2.default.func,
	  children: _propTypes2.default.node,
	  scroll: _propTypes2.default.func,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	
	HashLink.propTypes = propTypes;
	NavHashLink.propTypes = propTypes;

/***/ }),

/***/ 4138:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(402);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { "slick-arrow": true, "slick-prev": true };
	    var prevHandler = this.clickHandler.bind(this, { message: "previous" });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses["slick-disabled"] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: "0",
	      "data-role": "none",
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: "block" },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "0", type: "button" }, prevArrowProps),
	        " ",
	        "Previous"
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.PureComponent);
	
	var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { "slick-arrow": true, "slick-next": true };
	    var nextHandler = this.clickHandler.bind(this, { message: "next" });
	
	    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	      nextClasses["slick-disabled"] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: "1",
	      "data-role": "none",
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: "block" },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        "button",
	        _extends({ key: "1", type: "button" }, nextArrowProps),
	        " ",
	        "Next"
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.PureComponent);

/***/ }),

/***/ 4139:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react2.default.createElement(
	      "ul",
	      { style: { display: "block" } },
	      dots
	    );
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react2.default.createElement(
	      "button",
	      null,
	      i + 1
	    );
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	
	exports.default = defaultProps;

/***/ }),

/***/ 4140:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll,
	      slidesToShow: this.props.slidesToShow,
	      infinite: this.props.infinite
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: "dots",
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	      return _react2.default.createElement(
	        "li",
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
	      className: this.props.dotsClass
	    }, mouseEvents));
	  };
	
	  return Dots;
	}(_react2.default.PureComponent);

/***/ }),

/***/ 4141:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _slider = __webpack_require__(4144);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _slider2.default;

/***/ }),

/***/ 4142:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false, // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
	  trackStyle: {},
	  trackWidth: 0
	};
	
	exports.default = initialState;

/***/ }),

/***/ 4143:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(24);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _initialState = __webpack_require__(4142);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _lodash = __webpack_require__(3984);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(402);
	
	var _track = __webpack_require__(4145);
	
	var _dots = __webpack_require__(4140);
	
	var _arrows = __webpack_require__(4138);
	
	var _resizeObserverPolyfill = __webpack_require__(4265);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InnerSlider = exports.InnerSlider = function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    _classCallCheck(this, InnerSlider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.listRefHandler = function (ref) {
	      return _this.list = ref;
	    };
	
	    _this.trackRefHandler = function (ref) {
	      return _this.track = ref;
	    };
	
	    _this.adaptHeight = function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    };
	
	    _this.componentWillMount = function () {
	      _this.ssrInit();
	      _this.props.onInit && _this.props.onInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    };
	
	    _this.componentDidMount = function () {
	      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	      _this.ro = new _resizeObserverPolyfill2.default(function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	      _this.ro.observe(_this.list);
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      });
	      // To support server-side rendering
	      if (!window) {
	        return;
	      }
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    };
	
	    _this.componentWillUnmount = function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	        _this.callbackTimers = [];
	      }
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    };
	
	    _this.componentWillReceiveProps = function (nextProps) {
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, _this.state);
	      var setTrackStyle = false;
	      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var key = _ref;
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    };
	
	    _this.componentDidUpdate = function () {
	      _this.checkImagesLoad();
	      _this.props.onReInit && _this.props.onReInit();
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	      // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	      _this.adaptHeight();
	    };
	
	    _this.onWindowResized = function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash2.default)(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	      _this.debouncedResize();
	    };
	
	    _this.resizeWindow = function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (!_reactDom2.default.findDOMNode(_this.track)) return;
	      var spec = _extends({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, _this.state);
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      });
	      // animating state should be cleared while resizing, otherwise autoplay stops working
	      _this.setState({
	        animating: false
	      });
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    };
	
	    _this.updateState = function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _extends({}, spec, { left: targetLeft });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	      _this.setState(updatedState, callback);
	    };
	
	    _this.ssrInit = function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	        if (_this.props.centerMode) {
	          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
	          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
	        }
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	        return;
	      }
	      var childrenCount = _react2.default.Children.count(_this.props.children);
	      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    };
	
	    _this.checkImagesLoad = function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    };
	
	    _this.progressiveLazyLoad = function () {
	      var slidesToLoad = [];
	      var spec = _extends({}, _this.props, _this.state);
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    };
	
	    _this.slideHandler = function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          currentSlide = _this$props.currentSlide,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
	        index: index
	      }, _this.props, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({ animating: animating });
	            }, 10));
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    };
	
	    _this.changeSlide = function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _extends({}, _this.props, _this.state);
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    };
	
	    _this.clickHandler = function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      _this.clickable = true;
	    };
	
	    _this.keyHandler = function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({ message: dir });
	    };
	
	    _this.selectHandler = function (options) {
	      _this.changeSlide(options);
	    };
	
	    _this.disableBodyScroll = function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	      window.ontouchmove = preventDefault;
	    };
	
	    _this.enableBodyScroll = function () {
	      window.ontouchmove = null;
	    };
	
	    _this.swipeStart = function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    };
	
	    _this.swipeMove = function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	      _this.setState(state);
	    };
	
	    _this.swipeEnd = function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	      _this.setState(state);
	      if (triggerSlideHandler === undefined) return;
	      _this.slideHandler(triggerSlideHandler);
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    };
	
	    _this.slickPrev = function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "previous" });
	      }, 0));
	    };
	
	    _this.slickNext = function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({ message: "next" });
	      }, 0));
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    };
	
	    _this.play = function () {
	      var nextIndex;
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    };
	
	    _this.autoPlay = function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	      _this.setState({ autoplaying: "playing" });
	    };
	
	    _this.pause = function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	      var autoplaying = _this.state.autoplaying;
	      if (pauseType === "paused") {
	        _this.setState({ autoplaying: "paused" });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({ autoplaying: "focused" });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({ autoplaying: "hovered" });
	        }
	      }
	    };
	
	    _this.onDotsOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onDotsLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onTrackOver = function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    };
	
	    _this.onTrackLeave = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    };
	
	    _this.onSlideFocus = function () {
	      return _this.props.autoplay && _this.pause("focused");
	    };
	
	    _this.onSlideBlur = function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    };
	
	    _this.render = function () {
	      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	      var spec = _extends({}, _this.props, _this.state);
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	
	      trackProps = _extends({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	
	      var dots;
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	
	        dotProps = _extends({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react2.default.createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr"
	      };
	
	      if (_this.props.unslick) {
	        listProps = { className: "slick-list" };
	        innerSliderProps = { className: className };
	      }
	      return _react2.default.createElement(
	        "div",
	        innerSliderProps,
	        !_this.props.unslick ? prevArrow : "",
	        _react2.default.createElement(
	          "div",
	          _extends({ ref: _this.listRefHandler }, listProps),
	          _react2.default.createElement(
	            _track.Track,
	            _extends({ ref: _this.trackRefHandler }, trackProps),
	            _this.props.children
	          )
	        ),
	        !_this.props.unslick ? nextArrow : "",
	        !_this.props.unslick ? dots : ""
	      );
	    };
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _extends({}, _initialState2.default, {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react2.default.Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react2.default.Component);

/***/ }),

/***/ 4144:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(4143);
	
	var _json2mq = __webpack_require__(3983);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(4139);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _innerSliderUtils = __webpack_require__(402);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(1071);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.innerSliderRefHandler = function (ref) {
	      return _this.innerSlider = ref;
	    };
	
	    _this.slickPrev = function () {
	      return _this.innerSlider.slickPrev();
	    };
	
	    _this.slickNext = function () {
	      return _this.innerSlider.slickNext();
	    };
	
	    _this.slickGoTo = function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    };
	
	    _this.slickPause = function () {
	      return _this.innerSlider.pause("paused");
	    };
	
	    _this.slickPlay = function () {
	      return _this.innerSlider.autoPlay("play");
	    };
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  // handles responsive breakpoints
	
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // performance monitoring
	    //if (process.env.NODE_ENV !== 'production') {
	    //const { whyDidYouUpdate } = require('why-did-you-update')
	    //whyDidYouUpdate(React)
	    //}
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery = void 0;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({
	            minWidth: breakpoints[index - 1] + 1,
	            maxWidth: breakpoint
	          });
	        }
	        // when not using server side rendering
	        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = _extends({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && ("production") !== "production") {
	        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && ("production") !== "production") {
	        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === "string") {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    // rows and slidesPerRow logic is handled here
	    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	      settings.variableWidth = false;
	    }
	    var newChildren = [];
	    var currentWidth = null;
	    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	      var newSlide = [];
	      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	        var row = [];
	        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	          if (settings.variableWidth && children[k].props.style) {
	            currentWidth = children[k].props.style.width;
	          }
	          if (k >= children.length) break;
	          row.push(_react2.default.cloneElement(children[k], {
	            key: 100 * i + 10 * j + k,
	            tabIndex: -1,
	            style: {
	              width: 100 / settings.slidesPerRow + "%",
	              display: "inline-block"
	            }
	          }));
	        }
	        newSlide.push(_react2.default.createElement(
	          "div",
	          { key: 10 * i + j },
	          row
	        ));
	      }
	      if (settings.variableWidth) {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i, style: { width: currentWidth } },
	          newSlide
	        ));
	      } else {
	        newChildren.push(_react2.default.createElement(
	          "div",
	          { key: i },
	          newSlide
	        ));
	      }
	    }
	
	    if (settings === "unslick") {
	      var className = "regular slider " + (this.props.className || "");
	      return _react2.default.createElement(
	        "div",
	        { className: className },
	        newChildren
	      );
	    } else if (newChildren.length <= settings.slidesToShow) {
	      settings.unslick = true;
	    }
	    return _react2.default.createElement(
	      _innerSlider.InnerSlider,
	      _extends({ ref: this.innerSliderRefHandler }, settings),
	      newChildren
	    );
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ }),

/***/ 4145:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _innerSliderUtils = __webpack_require__(402);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement("div", null);
	    }
	    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames2.default)(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    }));
	
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        if (key >= startIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        if (key < endIndex) {
	          child = elem;
	        }
	        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames2.default)(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _extends({}, child.props.style || {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides(this.props);
	    var _props = this.props,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseOver = _props.onMouseOver,
	        onMouseLeave = _props.onMouseLeave;
	
	    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
	    return _react2.default.createElement(
	      "div",
	      _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents),
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.PureComponent);

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(24);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	  return onDemandSlides;
	};
	
	// return list of slides that need to be present
	var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	  return requiredSlides;
	};
	
	// startIndex that needs to be present
	var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	};
	
	// get width of an element
	var getWidth = exports.getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	var getHeight = exports.getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	};
	
	// whether or not we can go next
	var canGoNext = exports.canGoNext = function canGoNext(spec) {
	  var canGo = true;
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	  return canGo;
	};
	
	// given an object and a list of keys, return new object with given keys
	var extractObject = exports.extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	};
	
	// get initialized state
	var initializedState = exports.initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react2.default.Children.count(spec.children);
	  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
	  var slideWidth = void 0;
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	var slideHandler = exports.slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide = void 0,
	      animationLeft = void 0,
	      finalLeft = void 0;
	  var state = {},
	      nextState = {};
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = { animating: false };
	  } else {
	    finalSlide = animationSlide;
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
	    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
	        swipeLeft: null
	      };
	    }
	  }
	  return { state: state, nextState: nextState };
	};
	
	var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	    if (infinite) {
	      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	  return targetSlide;
	};
	var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft = void 0,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return { scrolling: true };
	  }
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	  state = _extends({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
	  });
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	  return state;
	};
	var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
	  // reset the state of touch related state variables.
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	  if (scrolling) {
	    return state;
	  }
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	    var slideCount = void 0,
	        newSlide = void 0;
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	      default:
	        slideCount = currentSlide;
	    }
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
	  }
	  return state;
	};
	var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	  return indexes;
	};
	var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	      prevNavigable = navigables[n];
	    }
	  }
	  return index;
	};
	var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	  if (spec.swipeToSlide) {
	    var swipedSlide = void 0;
	    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth = void 0,
	      trackHeight = void 0;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _extends({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	  if (spec.fade) style = { opacity: 1 };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight;
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	  return style;
	};
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var trackElem = _reactDom2.default.findDOMNode(trackRef);
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	var getPreClones = exports.getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	var getPostClones = exports.getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	  return spec.slideCount;
	};
	
	var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	    return "left";
	  }
	};
	
	var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	  if (rtl) {
	    return 0;
	  }
	  return slidesToShow - 1;
	};
	
	var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	  return 0;
	};
	
	var canUseDOM = exports.canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};

/***/ }),

/***/ 4265:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	/**
	 * A collection of shims that provide minimal functionality of the ES6 collections.
	 *
	 * These implementations are not meant to be used outside of the ResizeObserver
	 * modules as they cover only a limited range of use cases.
	 */
	/* eslint-disable require-jsdoc, valid-jsdoc */
	var MapShim = (function () {
	    if (typeof Map !== 'undefined') {
	        return Map;
	    }
	
	    /**
	     * Returns index in provided array that matches the specified key.
	     *
	     * @param {Array<Array>} arr
	     * @param {*} key
	     * @returns {number}
	     */
	    function getIndex(arr, key) {
	        var result = -1;
	
	        arr.some(function (entry, index) {
	            if (entry[0] === key) {
	                result = index;
	
	                return true;
	            }
	
	            return false;
	        });
	
	        return result;
	    }
	
	    return (function () {
	        function anonymous() {
	            this.__entries__ = [];
	        }
	
	        var prototypeAccessors = { size: { configurable: true } };
	
	        /**
	         * @returns {boolean}
	         */
	        prototypeAccessors.size.get = function () {
	            return this.__entries__.length;
	        };
	
	        /**
	         * @param {*} key
	         * @returns {*}
	         */
	        anonymous.prototype.get = function (key) {
	            var index = getIndex(this.__entries__, key);
	            var entry = this.__entries__[index];
	
	            return entry && entry[1];
	        };
	
	        /**
	         * @param {*} key
	         * @param {*} value
	         * @returns {void}
	         */
	        anonymous.prototype.set = function (key, value) {
	            var index = getIndex(this.__entries__, key);
	
	            if (~index) {
	                this.__entries__[index][1] = value;
	            } else {
	                this.__entries__.push([key, value]);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.delete = function (key) {
	            var entries = this.__entries__;
	            var index = getIndex(entries, key);
	
	            if (~index) {
	                entries.splice(index, 1);
	            }
	        };
	
	        /**
	         * @param {*} key
	         * @returns {void}
	         */
	        anonymous.prototype.has = function (key) {
	            return !!~getIndex(this.__entries__, key);
	        };
	
	        /**
	         * @returns {void}
	         */
	        anonymous.prototype.clear = function () {
	            this.__entries__.splice(0);
	        };
	
	        /**
	         * @param {Function} callback
	         * @param {*} [ctx=null]
	         * @returns {void}
	         */
	        anonymous.prototype.forEach = function (callback, ctx) {
	            var this$1 = this;
	            if ( ctx === void 0 ) ctx = null;
	
	            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
	                var entry = list[i];
	
	                callback.call(ctx, entry[1], entry[0]);
	            }
	        };
	
	        Object.defineProperties( anonymous.prototype, prototypeAccessors );
	
	        return anonymous;
	    }());
	})();
	
	/**
	 * Detects whether window and document objects are available in current environment.
	 */
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	// Returns global object of a current environment.
	var global$1 = (function () {
	    if (typeof global !== 'undefined' && global.Math === Math) {
	        return global;
	    }
	
	    if (typeof self !== 'undefined' && self.Math === Math) {
	        return self;
	    }
	
	    if (typeof window !== 'undefined' && window.Math === Math) {
	        return window;
	    }
	
	    // eslint-disable-next-line no-new-func
	    return Function('return this')();
	})();
	
	/**
	 * A shim for the requestAnimationFrame which falls back to the setTimeout if
	 * first one is not supported.
	 *
	 * @returns {number} Requests' identifier.
	 */
	var requestAnimationFrame$1 = (function () {
	    if (typeof requestAnimationFrame === 'function') {
	        // It's required to use a bounded function because IE sometimes throws
	        // an "Invalid calling object" error if rAF is invoked without the global
	        // object on the left hand side.
	        return requestAnimationFrame.bind(global$1);
	    }
	
	    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	})();
	
	// Defines minimum timeout before adding a trailing call.
	var trailingTimeout = 2;
	
	/**
	 * Creates a wrapper function which ensures that provided callback will be
	 * invoked only once during the specified delay period.
	 *
	 * @param {Function} callback - Function to be invoked after the delay period.
	 * @param {number} delay - Delay after which to invoke callback.
	 * @returns {Function}
	 */
	var throttle = function (callback, delay) {
	    var leadingCall = false,
	        trailingCall = false,
	        lastCallTime = 0;
	
	    /**
	     * Invokes the original callback function and schedules new invocation if
	     * the "proxy" was called during current request.
	     *
	     * @returns {void}
	     */
	    function resolvePending() {
	        if (leadingCall) {
	            leadingCall = false;
	
	            callback();
	        }
	
	        if (trailingCall) {
	            proxy();
	        }
	    }
	
	    /**
	     * Callback invoked after the specified delay. It will further postpone
	     * invocation of the original function delegating it to the
	     * requestAnimationFrame.
	     *
	     * @returns {void}
	     */
	    function timeoutCallback() {
	        requestAnimationFrame$1(resolvePending);
	    }
	
	    /**
	     * Schedules invocation of the original function.
	     *
	     * @returns {void}
	     */
	    function proxy() {
	        var timeStamp = Date.now();
	
	        if (leadingCall) {
	            // Reject immediately following calls.
	            if (timeStamp - lastCallTime < trailingTimeout) {
	                return;
	            }
	
	            // Schedule new call to be in invoked when the pending one is resolved.
	            // This is important for "transitions" which never actually start
	            // immediately so there is a chance that we might miss one if change
	            // happens amids the pending invocation.
	            trailingCall = true;
	        } else {
	            leadingCall = true;
	            trailingCall = false;
	
	            setTimeout(timeoutCallback, delay);
	        }
	
	        lastCallTime = timeStamp;
	    }
	
	    return proxy;
	};
	
	// Minimum delay before invoking the update of observers.
	var REFRESH_DELAY = 20;
	
	// A list of substrings of CSS properties used to find transition events that
	// might affect dimensions of observed elements.
	var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	
	// Check if MutationObserver is available.
	var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	
	/**
	 * Singleton controller class which handles updates of ResizeObserver instances.
	 */
	var ResizeObserverController = function() {
	    this.connected_ = false;
	    this.mutationEventsAdded_ = false;
	    this.mutationsObserver_ = null;
	    this.observers_ = [];
	
	    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	};
	
	/**
	 * Adds observer to observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be added.
	 * @returns {void}
	 */
	
	
	/**
	 * Holds reference to the controller's instance.
	 *
	 * @private {ResizeObserverController}
	 */
	
	
	/**
	 * Keeps reference to the instance of MutationObserver.
	 *
	 * @private {MutationObserver}
	 */
	
	/**
	 * Indicates whether DOM listeners have been added.
	 *
	 * @private {boolean}
	 */
	ResizeObserverController.prototype.addObserver = function (observer) {
	    if (!~this.observers_.indexOf(observer)) {
	        this.observers_.push(observer);
	    }
	
	    // Add listeners if they haven't been added yet.
	    if (!this.connected_) {
	        this.connect_();
	    }
	};
	
	/**
	 * Removes observer from observers list.
	 *
	 * @param {ResizeObserverSPI} observer - Observer to be removed.
	 * @returns {void}
	 */
	ResizeObserverController.prototype.removeObserver = function (observer) {
	    var observers = this.observers_;
	    var index = observers.indexOf(observer);
	
	    // Remove observer if it's present in registry.
	    if (~index) {
	        observers.splice(index, 1);
	    }
	
	    // Remove listeners if controller has no connected observers.
	    if (!observers.length && this.connected_) {
	        this.disconnect_();
	    }
	};
	
	/**
	 * Invokes the update of observers. It will continue running updates insofar
	 * it detects changes.
	 *
	 * @returns {void}
	 */
	ResizeObserverController.prototype.refresh = function () {
	    var changesDetected = this.updateObservers_();
	
	    // Continue running updates if changes have been detected as there might
	    // be future ones caused by CSS transitions.
	    if (changesDetected) {
	        this.refresh();
	    }
	};
	
	/**
	 * Updates every observer from observers list and notifies them of queued
	 * entries.
	 *
	 * @private
	 * @returns {boolean} Returns "true" if any observer has detected changes in
	 *  dimensions of it's elements.
	 */
	ResizeObserverController.prototype.updateObservers_ = function () {
	    // Collect observers that have active observations.
	    var activeObservers = this.observers_.filter(function (observer) {
	        return observer.gatherActive(), observer.hasActive();
	    });
	
	    // Deliver notifications in a separate cycle in order to avoid any
	    // collisions between observers, e.g. when multiple instances of
	    // ResizeObserver are tracking the same element and the callback of one
	    // of them changes content dimensions of the observed target. Sometimes
	    // this may result in notifications being blocked for the rest of observers.
	    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	
	    return activeObservers.length > 0;
	};
	
	/**
	 * Initializes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.connect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already added.
	    if (!isBrowser || this.connected_) {
	        return;
	    }
	
	    // Subscription to the "Transitionend" event is used as a workaround for
	    // delayed transitions. This way it's possible to capture at least the
	    // final state of an element.
	    document.addEventListener('transitionend', this.onTransitionEnd_);
	
	    window.addEventListener('resize', this.refresh);
	
	    if (mutationObserverSupported) {
	        this.mutationsObserver_ = new MutationObserver(this.refresh);
	
	        this.mutationsObserver_.observe(document, {
	            attributes: true,
	            childList: true,
	            characterData: true,
	            subtree: true
	        });
	    } else {
	        document.addEventListener('DOMSubtreeModified', this.refresh);
	
	        this.mutationEventsAdded_ = true;
	    }
	
	    this.connected_ = true;
	};
	
	/**
	 * Removes DOM listeners.
	 *
	 * @private
	 * @returns {void}
	 */
	ResizeObserverController.prototype.disconnect_ = function () {
	    // Do nothing if running in a non-browser environment or if listeners
	    // have been already removed.
	    if (!isBrowser || !this.connected_) {
	        return;
	    }
	
	    document.removeEventListener('transitionend', this.onTransitionEnd_);
	    window.removeEventListener('resize', this.refresh);
	
	    if (this.mutationsObserver_) {
	        this.mutationsObserver_.disconnect();
	    }
	
	    if (this.mutationEventsAdded_) {
	        document.removeEventListener('DOMSubtreeModified', this.refresh);
	    }
	
	    this.mutationsObserver_ = null;
	    this.mutationEventsAdded_ = false;
	    this.connected_ = false;
	};
	
	/**
	 * "Transitionend" event handler.
	 *
	 * @private
	 * @param {TransitionEvent} event
	 * @returns {void}
	 */
	ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
	        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';
	
	    // Detect whether transition may affect dimensions of an element.
	    var isReflowProperty = transitionKeys.some(function (key) {
	        return !!~propertyName.indexOf(key);
	    });
	
	    if (isReflowProperty) {
	        this.refresh();
	    }
	};
	
	/**
	 * Returns instance of the ResizeObserverController.
	 *
	 * @returns {ResizeObserverController}
	 */
	ResizeObserverController.getInstance = function () {
	    if (!this.instance_) {
	        this.instance_ = new ResizeObserverController();
	    }
	
	    return this.instance_;
	};
	
	ResizeObserverController.instance_ = null;
	
	/**
	 * Defines non-writable/enumerable properties of the provided target object.
	 *
	 * @param {Object} target - Object for which to define properties.
	 * @param {Object} props - Properties to be defined.
	 * @returns {Object} Target object.
	 */
	var defineConfigurable = (function (target, props) {
	    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
	        var key = list[i];
	
	        Object.defineProperty(target, key, {
	            value: props[key],
	            enumerable: false,
	            writable: false,
	            configurable: true
	        });
	    }
	
	    return target;
	});
	
	/**
	 * Returns the global object associated with provided element.
	 *
	 * @param {Object} target
	 * @returns {Object}
	 */
	var getWindowOf = (function (target) {
	    // Assume that the element is an instance of Node, which means that it
	    // has the "ownerDocument" property from which we can retrieve a
	    // corresponding global object.
	    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	
	    // Return the local global object if it's not possible extract one from
	    // provided element.
	    return ownerGlobal || global$1;
	});
	
	// Placeholder of an empty content rectangle.
	var emptyRect = createRectInit(0, 0, 0, 0);
	
	/**
	 * Converts provided string to a number.
	 *
	 * @param {number|string} value
	 * @returns {number}
	 */
	function toFloat(value) {
	    return parseFloat(value) || 0;
	}
	
	/**
	 * Extracts borders size from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @param {...string} positions - Borders positions (top, right, ...)
	 * @returns {number}
	 */
	function getBordersSize(styles) {
	    var positions = [], len = arguments.length - 1;
	    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];
	
	    return positions.reduce(function (size, position) {
	        var value = styles['border-' + position + '-width'];
	
	        return size + toFloat(value);
	    }, 0);
	}
	
	/**
	 * Extracts paddings sizes from provided styles.
	 *
	 * @param {CSSStyleDeclaration} styles
	 * @returns {Object} Paddings box.
	 */
	function getPaddings(styles) {
	    var positions = ['top', 'right', 'bottom', 'left'];
	    var paddings = {};
	
	    for (var i = 0, list = positions; i < list.length; i += 1) {
	        var position = list[i];
	
	        var value = styles['padding-' + position];
	
	        paddings[position] = toFloat(value);
	    }
	
	    return paddings;
	}
	
	/**
	 * Calculates content rectangle of provided SVG element.
	 *
	 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	 *      to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getSVGContentRect(target) {
	    var bbox = target.getBBox();
	
	    return createRectInit(0, 0, bbox.width, bbox.height);
	}
	
	/**
	 * Calculates content rectangle of provided HTMLElement.
	 *
	 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	 * @returns {DOMRectInit}
	 */
	function getHTMLElementContentRect(target) {
	    // Client width & height properties can't be
	    // used exclusively as they provide rounded values.
	    var clientWidth = target.clientWidth;
	    var clientHeight = target.clientHeight;
	
	    // By this condition we can catch all non-replaced inline, hidden and
	    // detached elements. Though elements with width & height properties less
	    // than 0.5 will be discarded as well.
	    //
	    // Without it we would need to implement separate methods for each of
	    // those cases and it's not possible to perform a precise and performance
	    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	    // gives wrong results for elements with width & height less than 0.5.
	    if (!clientWidth && !clientHeight) {
	        return emptyRect;
	    }
	
	    var styles = getWindowOf(target).getComputedStyle(target);
	    var paddings = getPaddings(styles);
	    var horizPad = paddings.left + paddings.right;
	    var vertPad = paddings.top + paddings.bottom;
	
	    // Computed styles of width & height are being used because they are the
	    // only dimensions available to JS that contain non-rounded values. It could
	    // be possible to utilize the getBoundingClientRect if only it's data wasn't
	    // affected by CSS transformations let alone paddings, borders and scroll bars.
	    var width = toFloat(styles.width),
	        height = toFloat(styles.height);
	
	    // Width & height include paddings and borders when the 'border-box' box
	    // model is applied (except for IE).
	    if (styles.boxSizing === 'border-box') {
	        // Following conditions are required to handle Internet Explorer which
	        // doesn't include paddings and borders to computed CSS dimensions.
	        //
	        // We can say that if CSS dimensions + paddings are equal to the "client"
	        // properties then it's either IE, and thus we don't need to subtract
	        // anything, or an element merely doesn't have paddings/borders styles.
	        if (Math.round(width + horizPad) !== clientWidth) {
	            width -= getBordersSize(styles, 'left', 'right') + horizPad;
	        }
	
	        if (Math.round(height + vertPad) !== clientHeight) {
	            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	        }
	    }
	
	    // Following steps can't be applied to the document's root element as its
	    // client[Width/Height] properties represent viewport area of the window.
	    // Besides, it's as well not necessary as the <html> itself neither has
	    // rendered scroll bars nor it can be clipped.
	    if (!isDocumentElement(target)) {
	        // In some browsers (only in Firefox, actually) CSS width & height
	        // include scroll bars size which can be removed at this step as scroll
	        // bars are the only difference between rounded dimensions + paddings
	        // and "client" properties, though that is not always true in Chrome.
	        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	
	        // Chrome has a rather weird rounding of "client" properties.
	        // E.g. for an element with content width of 314.2px it sometimes gives
	        // the client width of 315px and for the width of 314.7px it may give
	        // 314px. And it doesn't happen all the time. So just ignore this delta
	        // as a non-relevant.
	        if (Math.abs(vertScrollbar) !== 1) {
	            width -= vertScrollbar;
	        }
	
	        if (Math.abs(horizScrollbar) !== 1) {
	            height -= horizScrollbar;
	        }
	    }
	
	    return createRectInit(paddings.left, paddings.top, width, height);
	}
	
	/**
	 * Checks whether provided element is an instance of the SVGGraphicsElement.
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	var isSVGGraphicsElement = (function () {
	    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	    // interface.
	    if (typeof SVGGraphicsElement !== 'undefined') {
	        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	    }
	
	    // If it's so, then check that element is at least an instance of the
	    // SVGElement and that it has the "getBBox" method.
	    // eslint-disable-next-line no-extra-parens
	    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
	})();
	
	/**
	 * Checks whether provided element is a document element (<html>).
	 *
	 * @param {Element} target - Element to be checked.
	 * @returns {boolean}
	 */
	function isDocumentElement(target) {
	    return target === getWindowOf(target).document.documentElement;
	}
	
	/**
	 * Calculates an appropriate content rectangle for provided html or svg element.
	 *
	 * @param {Element} target - Element content rectangle of which needs to be calculated.
	 * @returns {DOMRectInit}
	 */
	function getContentRect(target) {
	    if (!isBrowser) {
	        return emptyRect;
	    }
	
	    if (isSVGGraphicsElement(target)) {
	        return getSVGContentRect(target);
	    }
	
	    return getHTMLElementContentRect(target);
	}
	
	/**
	 * Creates rectangle with an interface of the DOMRectReadOnly.
	 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	 *
	 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	 * @returns {DOMRectReadOnly}
	 */
	function createReadOnlyRect(ref) {
	    var x = ref.x;
	    var y = ref.y;
	    var width = ref.width;
	    var height = ref.height;
	
	    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	    var rect = Object.create(Constr.prototype);
	
	    // Rectangle's properties are not writable and non-enumerable.
	    defineConfigurable(rect, {
	        x: x, y: y, width: width, height: height,
	        top: y,
	        right: x + width,
	        bottom: height + y,
	        left: x
	    });
	
	    return rect;
	}
	
	/**
	 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	 *
	 * @param {number} x - X coordinate.
	 * @param {number} y - Y coordinate.
	 * @param {number} width - Rectangle's width.
	 * @param {number} height - Rectangle's height.
	 * @returns {DOMRectInit}
	 */
	function createRectInit(x, y, width, height) {
	    return { x: x, y: y, width: width, height: height };
	}
	
	/**
	 * Class that is responsible for computations of the content rectangle of
	 * provided DOM element and for keeping track of it's changes.
	 */
	var ResizeObservation = function(target) {
	    this.broadcastWidth = 0;
	    this.broadcastHeight = 0;
	    this.contentRect_ = createRectInit(0, 0, 0, 0);
	
	    this.target = target;
	};
	
	/**
	 * Updates content rectangle and tells whether it's width or height properties
	 * have changed since the last broadcast.
	 *
	 * @returns {boolean}
	 */
	
	
	/**
	 * Reference to the last observed content rectangle.
	 *
	 * @private {DOMRectInit}
	 */
	
	
	/**
	 * Broadcasted width of content rectangle.
	 *
	 * @type {number}
	 */
	ResizeObservation.prototype.isActive = function () {
	    var rect = getContentRect(this.target);
	
	    this.contentRect_ = rect;
	
	    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
	};
	
	/**
	 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	 * from the corresponding properties of the last observed content rectangle.
	 *
	 * @returns {DOMRectInit} Last observed content rectangle.
	 */
	ResizeObservation.prototype.broadcastRect = function () {
	    var rect = this.contentRect_;
	
	    this.broadcastWidth = rect.width;
	    this.broadcastHeight = rect.height;
	
	    return rect;
	};
	
	var ResizeObserverEntry = function(target, rectInit) {
	    var contentRect = createReadOnlyRect(rectInit);
	
	    // According to the specification following properties are not writable
	    // and are also not enumerable in the native implementation.
	    //
	    // Property accessors are not being used as they'd require to define a
	    // private WeakMap storage which may cause memory leaks in browsers that
	    // don't support this type of collections.
	    defineConfigurable(this, { target: target, contentRect: contentRect });
	};
	
	var ResizeObserverSPI = function(callback, controller, callbackCtx) {
	    this.activeObservations_ = [];
	    this.observations_ = new MapShim();
	
	    if (typeof callback !== 'function') {
	        throw new TypeError('The callback provided as parameter 1 is not a function.');
	    }
	
	    this.callback_ = callback;
	    this.controller_ = controller;
	    this.callbackCtx_ = callbackCtx;
	};
	
	/**
	 * Starts observing provided element.
	 *
	 * @param {Element} target - Element to be observed.
	 * @returns {void}
	 */
	
	
	/**
	 * Registry of the ResizeObservation instances.
	 *
	 * @private {Map<Element, ResizeObservation>}
	 */
	
	
	/**
	 * Public ResizeObserver instance which will be passed to the callback
	 * function and used as a value of it's "this" binding.
	 *
	 * @private {ResizeObserver}
	 */
	
	/**
	 * Collection of resize observations that have detected changes in dimensions
	 * of elements.
	 *
	 * @private {Array<ResizeObservation>}
	 */
	ResizeObserverSPI.prototype.observe = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is already being observed.
	    if (observations.has(target)) {
	        return;
	    }
	
	    observations.set(target, new ResizeObservation(target));
	
	    this.controller_.addObserver(this);
	
	    // Force the update of observations.
	    this.controller_.refresh();
	};
	
	/**
	 * Stops observing provided element.
	 *
	 * @param {Element} target - Element to stop observing.
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.unobserve = function (target) {
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    // Do nothing if current environment doesn't have the Element interface.
	    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	        return;
	    }
	
	    if (!(target instanceof getWindowOf(target).Element)) {
	        throw new TypeError('parameter 1 is not of type "Element".');
	    }
	
	    var observations = this.observations_;
	
	    // Do nothing if element is not being observed.
	    if (!observations.has(target)) {
	        return;
	    }
	
	    observations.delete(target);
	
	    if (!observations.size) {
	        this.controller_.removeObserver(this);
	    }
	};
	
	/**
	 * Stops observing all elements.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.disconnect = function () {
	    this.clearActive();
	    this.observations_.clear();
	    this.controller_.removeObserver(this);
	};
	
	/**
	 * Collects observation instances the associated element of which has changed
	 * it's content rectangle.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.gatherActive = function () {
	        var this$1 = this;
	
	    this.clearActive();
	
	    this.observations_.forEach(function (observation) {
	        if (observation.isActive()) {
	            this$1.activeObservations_.push(observation);
	        }
	    });
	};
	
	/**
	 * Invokes initial callback function with a list of ResizeObserverEntry
	 * instances collected from active resize observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.broadcastActive = function () {
	    // Do nothing if observer doesn't have active observations.
	    if (!this.hasActive()) {
	        return;
	    }
	
	    var ctx = this.callbackCtx_;
	
	    // Create ResizeObserverEntry instance for every active observation.
	    var entries = this.activeObservations_.map(function (observation) {
	        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	    });
	
	    this.callback_.call(ctx, entries, ctx);
	    this.clearActive();
	};
	
	/**
	 * Clears the collection of active observations.
	 *
	 * @returns {void}
	 */
	ResizeObserverSPI.prototype.clearActive = function () {
	    this.activeObservations_.splice(0);
	};
	
	/**
	 * Tells whether observer has active observations.
	 *
	 * @returns {boolean}
	 */
	ResizeObserverSPI.prototype.hasActive = function () {
	    return this.activeObservations_.length > 0;
	};
	
	// Registry of internal observers. If WeakMap is not available use current shim
	// for the Map collection as it has all required methods and because WeakMap
	// can't be fully polyfilled anyway.
	var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	
	/**
	 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	 * exposing only those methods and properties that are defined in the spec.
	 */
	var ResizeObserver = function(callback) {
	    if (!(this instanceof ResizeObserver)) {
	        throw new TypeError('Cannot call a class as a function.');
	    }
	    if (!arguments.length) {
	        throw new TypeError('1 argument required, but only 0 present.');
	    }
	
	    var controller = ResizeObserverController.getInstance();
	    var observer = new ResizeObserverSPI(callback, controller, this);
	
	    observers.set(this, observer);
	};
	
	// Expose public methods of ResizeObserver.
	['observe', 'unobserve', 'disconnect'].forEach(function (method) {
	    ResizeObserver.prototype[method] = function () {
	        return (ref = observers.get(this))[method].apply(ref, arguments);
	        var ref;
	    };
	});
	
	var index = (function () {
	    // Export existing implementation if available.
	    if (typeof global$1.ResizeObserver !== 'undefined') {
	        return global$1.ResizeObserver;
	    }
	
	    return ResizeObserver;
	})();
	
	return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 4271:
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLazyload = __webpack_require__(348);
	
	var _reactLazyload2 = _interopRequireDefault(_reactLazyload);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Card = __webpack_require__(363);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardContent = __webpack_require__(236);
	
	var _CardContent2 = _interopRequireDefault(_CardContent);
	
	var _CircularProgress = __webpack_require__(238);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _Fade = __webpack_require__(128);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _styleUtils = __webpack_require__(369);
	
	var _formatCategory = __webpack_require__(214);
	
	var _formatCategory2 = _interopRequireDefault(_formatCategory);
	
	var _formatDate = __webpack_require__(133);
	
	var _formatDate2 = _interopRequireDefault(_formatDate);
	
	var _getRandomColor = __webpack_require__(288);
	
	var _getRandomColor2 = _interopRequireDefault(_getRandomColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _circularProgress, _container, _thumbnailWrapped, _contentWrapper, _title, _meta, _metaCategory, _metaTimesWrapper, _metaTimes, _extends2;
	
	  return {
	    circularProgress: (_circularProgress = {
	      display: 'block',
	      margin: 'auto',
	      minHeight: 195
	    }, _circularProgress[theme.breakpoints.down('md')] = {
	      minHeight: 182
	    }, _circularProgress),
	    container: (_container = {
	      marginBottom: 40,
	      overflow: 'hidden',
	      height: 195
	    }, _container[theme.breakpoints.down('md')] = {
	      height: 182
	    }, _container[theme.breakpoints.down('xs')] = {
	      border: '1px solid ' + theme.palette.borders.cloud,
	      height: 'auto',
	      marginBottom: 15
	    }, _container['&:hover'] = {
	      '& img': {
	        transform: 'scale(1.3) rotate(-10deg)'
	      }
	    }, _container),
	    thumbnailWrapped: (_thumbnailWrapped = {
	      width: '100%',
	      height: '100%',
	      overflow: 'hidden'
	    }, _thumbnailWrapped[theme.breakpoints.down('xs')] = {
	      height: 190
	    }, _thumbnailWrapped),
	    thumbnail: {
	      height: '100%',
	      width: '100%',
	      objectFit: 'cover',
	      transition: 'transform 0.5s, opacity 1s ease-in !important'
	    },
	    contentWrapper: (_contentWrapper = {
	      height: '100%',
	      boxShadow: 'none'
	    }, _contentWrapper[theme.breakpoints.down('sm')] = {
	      fontSize: '0.9em'
	    }, _contentWrapper[theme.breakpoints.down('xs')] = {
	      padding: 0
	    }, _contentWrapper),
	    title: (_title = {
	      fontWeight: 500
	    }, _title[theme.breakpoints.down('md')] = {
	      fontSize: '1.25em'
	    }, _title[theme.breakpoints.down('xs')] = {
	      fontSize: '1em'
	    }, _title),
	    meta: (_meta = {
	      color: theme.palette.text.soft,
	      fontStyle: 'italic',
	      fontWeight: 300,
	      opacity: 0.8,
	      width: '100%'
	    }, _meta[theme.breakpoints.down('xs')] = {
	      fontSize: '0.9em',
	      position: 'relative',
	      height: 18
	    }, _meta),
	    metaCategory: (_metaCategory = {
	      color: theme.palette.accent.noticeLight,
	      fontWeight: 500,
	      fontStyle: 'normal',
	      opacity: 0.8,
	      display: 'inline-block'
	    }, _metaCategory[theme.breakpoints.down('md')] = {
	      fontSize: '0.9em'
	    }, _metaCategory[theme.breakpoints.down('xs')] = {
	      position: 'absolute'
	    }, _metaCategory),
	    metaTimesWrapper: (_metaTimesWrapper = {
	      float: 'right'
	    }, _metaTimesWrapper[theme.breakpoints.down('xs')] = {
	      float: 'none',
	      position: 'absolute',
	      right: 0,
	      top: 4
	    }, _metaTimesWrapper),
	    metaTimes: (_metaTimes = {
	      float: 'right',
	      color: theme.palette.text.light
	    }, _metaTimes[theme.breakpoints.down('md')] = {
	      fontSize: '0.85em'
	    }, _metaTimes[theme.breakpoints.down('xs')] = {
	      // display: 'block',
	      fontSize: '0.9em',
	      marginTop: -5,
	      float: 'none',
	      fontStyle: 'normal',
	      textAlign: 'right'
	    }, _metaTimes),
	    excerpt: _extends({
	      color: theme.palette.text.main,
	      lineHeight: 1.8,
	      fontWeight: 300,
	      fontSize: '1em'
	    }, (0, _styleUtils.noTextOverflow)({
	      whiteSpace: 'normal',
	      '&:hover': {}
	    }), (_extends2 = {}, _extends2[theme.breakpoints.down('md')] = {
	      maxHeight: 75,
	      fontSize: '0.9em'
	    }, _extends2[theme.breakpoints.down('xs')] = {
	      fontSize: '0.8em',
	      lineHeight: 1.5,
	      maxHeight: 85,
	      marginTop: 5
	    }, _extends2))
	  };
	};
	
	var Article = function Article(_ref) {
	  var index = _ref.index,
	      id = _ref.id,
	      classes = _ref.classes,
	      slug = _ref.slug,
	      timeToRead = _ref.timeToRead,
	      title = _ref.title,
	      uiTitle = _ref.uiTitle,
	      date = _ref.date,
	      src = _ref.src,
	      excerpt = _ref.excerpt,
	      category = _ref.category,
	      pageType = _ref.pageType;
	
	  var rootProps = {};
	  if (id) {
	    rootProps.id = id;
	  }
	
	  var pageProps = {};
	  var categoryProps = {};
	
	  if (pageType === 'review') {
	    pageProps.title = uiTitle;
	    pageProps.category = 'Review';
	  } else {
	    pageProps.title = title;
	    pageProps.category = category;
	    categoryProps.component = _gatsbyLink2.default;
	    categoryProps.to = '/' + category;
	  }
	
	  var Image = function Image(props) {
	    return _react2.default.createElement('img', props);
	  }; // Fade passes in mandatory style prop
	
	  var color = (0, _getRandomColor2.default)();
	
	  return _react2.default.createElement(
	    _Grid2.default,
	    _extends({}, rootProps, {
	      classes: { container: classes.container },
	      spacing: 0,
	      container: true
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { xs: 12, sm: 4, item: true },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: slug },
	        src && _react2.default.createElement(
	          'div',
	          { className: classes.thumbnailWrapped },
	          _react2.default.createElement(
	            _reactLazyload2.default,
	            {
	              placeholder: _react2.default.createElement(_CircularProgress2.default, {
	                className: classes.circularProgress,
	                style: { color: color },
	                size: 150,
	                thickness: 1
	              }),
	              once: true
	            },
	            _react2.default.createElement(
	              _Fade2.default,
	              { timeout: 2000, 'in': true },
	              _react2.default.createElement(Image, {
	                src: src,
	                className: classes.thumbnail,
	                alt: pageProps.title,
	                title: pageProps.title
	              })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Grid2.default,
	      { xs: 12, sm: 8, item: true },
	      _react2.default.createElement(
	        _Card2.default,
	        { className: classes.contentWrapper },
	        _react2.default.createElement(
	          _CardContent2.default,
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            {
	              variant: 'headline',
	              classes: { root: classes.title },
	              component: _gatsbyLink2.default,
	              to: slug,
	              gutterBottom: true
	            },
	            pageProps.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.meta },
	            _react2.default.createElement(
	              _Typography2.default,
	              _extends({}, categoryProps, {
	                variant: 'subheading',
	                classes: { root: classes.metaCategory }
	              }),
	              pageType === 'review' ? 'Review' : (0, _formatCategory2.default)(category),
	              ' '
	            ),
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: classes.metaTimesWrapper },
	              _react2.default.createElement(
	                _Typography2.default,
	                { classes: { root: classes.metaTimes } },
	                (0, _formatDate2.default)(date, 'MMMM Do'),
	                ' ',
	                '\u2022',
	                ' ',
	                timeToRead,
	                ' min read'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { classes: { root: classes.excerpt } },
	            excerpt
	          )
	        )
	      )
	    )
	  );
	};
	
	Article.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  index: _propTypes2.default.number,
	  slug: _propTypes2.default.string.isRequired,
	  timeToRead: _propTypes2.default.number.isRequired,
	  excerpt: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  uiTitle: _propTypes2.default.string,
	  date: _propTypes2.default.string.isRequired,
	  src: _propTypes2.default.string.isRequired,
	  category: _propTypes2.default.string,
	  pageType: _propTypes2.default.string
	};
	
	exports.default = (0, _withStyles2.default)(styles)(Article);
	module.exports = exports['default'];

/***/ }),

/***/ 922:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _reactRouterHashLink = __webpack_require__(824);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Instagram = __webpack_require__(923);
	
	var _Instagram2 = _interopRequireDefault(_Instagram);
	
	var _Sidebar = __webpack_require__(522);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _ArticleItem = __webpack_require__(286);
	
	var _ArticleItem2 = _interopRequireDefault(_ArticleItem);
	
	var _Phaser = __webpack_require__(132);
	
	var _Phaser2 = _interopRequireDefault(_Phaser);
	
	var _HomeSubscribeForm = __webpack_require__(956);
	
	var _HomeSubscribeForm2 = _interopRequireDefault(_HomeSubscribeForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _root, _subheading, _subscriberCta, _left, _right, _seeMoreWrapper;
	
	  return {
	    root: (_root = {
	      paddingBottom: 20
	    }, _root[theme.breakpoints.down('xs')] = {
	      paddingTop: 0
	    }, _root),
	    subheading: (_subheading = {
	      color: '#fff',
	      textTransform: 'uppercase',
	      textAlign: 'center',
	      fontWeight: 300,
	      paddingBottom: 30
	    }, _subheading[theme.breakpoints.down('xs')] = {
	      fontSize: '0.7em',
	      maxHeight: 23,
	      padding: 6,
	      marginBottom: 7,
	      fontWeight: 300
	    }, _subheading),
	    subscriberCta: (_subscriberCta = {}, _subscriberCta[theme.breakpoints.down('xs')] = {
	      fontSize: '0.75em'
	    }, _subscriberCta),
	    left: (_left = {
	      width: 950
	    }, _left[theme.breakpoints.down('md')] = {
	      width: 670
	    }, _left[theme.breakpoints.down('sm')] = {
	      width: '90%'
	    }, _left[theme.breakpoints.down('xs')] = {}, _left),
	    right: (_right = {
	      width: 300
	    }, _right[theme.breakpoints.down('md')] = {
	      width: 280
	    }, _right[theme.breakpoints.down('sm')] = {
	      display: 'none'
	    }, _right),
	    seeMoreWrapper: (_seeMoreWrapper = {}, _seeMoreWrapper[theme.breakpoints.down('xs')] = {
	      textAlign: 'right'
	    }, _seeMoreWrapper)
	  };
	};
	
	var ArticlesSlide = function ArticlesSlide(_ref) {
	  var classes = _ref.classes,
	      articles = _ref.articles,
	      tags = _ref.tags,
	      featuredStories = _ref.featuredStories,
	      instagramPosts = _ref.instagramPosts;
	  return _react2.default.createElement(
	    _Grid2.default,
	    { className: classes.root, spacing: 24, justify: 'center', container: true },
	    _react2.default.createElement(
	      _Grid2.default,
	      { classes: { item: classes.left }, item: true },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Phaser2.default, { label: 'Subscribe to our newsletters', upperCase: true, noBottom: true }),
	        _react2.default.createElement(
	          _Typography2.default,
	          { className: classes.subscriberCta },
	          'Become a subscriber today to start receiving health newsletters delivered straight to your inbox. Never miss a single article! (You only need to enter your email. It\'s dead simple!)'
	        ),
	        _react2.default.createElement(_HomeSubscribeForm2.default, null)
	      ),
	      instagramPosts && _react2.default.createElement(_Phaser2.default, { label: 'Inspiration', upperCase: true }),
	      instagramPosts && _react2.default.createElement(_Instagram2.default, { items: instagramPosts }),
	      _react2.default.createElement(_Phaser2.default, { label: 'Latest Articles', upperCase: true }),
	      articles.map(function (_ref2, i) {
	        var node = _ref2.node;
	        return _react2.default.createElement(_ArticleItem2.default, {
	          index: i,
	          id: i === 0 && 'articles',
	          key: node.fields.slug,
	          slug: node.fields.slug,
	          timeToRead: node.timeToRead,
	          excerpt: node.excerpt,
	          title: node.frontmatter.title,
	          uiTitle: node.frontmatter.uiTitle,
	          date: node.frontmatter.date,
	          src: node.frontmatter.thumbnail,
	          category: node.frontmatter.category,
	          pageType: node.frontmatter.pageType
	        });
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: classes.seeMoreWrapper },
	        _react2.default.createElement(
	          _reactRouterHashLink.HashLink,
	          { to: '/weight-loss-articles' },
	          _react2.default.createElement(
	            _Button2.default,
	            { variant: 'raised', color: 'primary', size: 'medium' },
	            'See more'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Grid2.default,
	      { classes: { item: classes.right }, item: true },
	      _react2.default.createElement(_Sidebar2.default, { posts: articles, tags: tags, featuredStories: featuredStories })
	    )
	  );
	};
	
	ArticlesSlide.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  articles: _propTypes2.default.array.isRequired,
	  tags: _propTypes2.default.array.isRequired,
	  featuredStories: _propTypes2.default.object,
	  instagramPosts: _propTypes2.default.array
	};
	
	exports.default = (0, _withStyles2.default)(styles)(ArticlesSlide);
	module.exports = exports['default'];

/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _GridList = __webpack_require__(437);
	
	var _GridList2 = _interopRequireDefault(_GridList);
	
	var _GridListTile = __webpack_require__(439);
	
	var _GridListTile2 = _interopRequireDefault(_GridListTile);
	
	var _GridListTileBar = __webpack_require__(441);
	
	var _GridListTileBar2 = _interopRequireDefault(_GridListTileBar);
	
	var _reactSlick = __webpack_require__(4141);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _chevronLeft = __webpack_require__(4058);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(4059);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _iosCircleFilled = __webpack_require__(4055);
	
	var _iosCircleFilled2 = _interopRequireDefault(_iosCircleFilled);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _root, _thumbnail, _arrow, _pagingDot;
	
	  return {
	    root: (_root = {
	      width: '100%'
	    }, _root[theme.breakpoints.down('xs')] = {
	      marginBottom: 25
	    }, _root),
	    thumbnailWrapper: {
	      '&:hover': {
	        '& img': {
	          transform: 'scale(0.88) rotate(2deg)'
	        }
	      }
	    },
	    thumbnail: (_thumbnail = {
	      borderRadius: '50%',
	      maxWidth: 140,
	      transition: 'transform 0.4s'
	    }, _thumbnail[theme.breakpoints.down('xs')] = {
	      maxWidth: 70
	    }, _thumbnail),
	    profileCaption: {
	      color: theme.palette.primary.light + ' !important',
	      '&:hover': {
	        color: '#36edff !important',
	        opacity: 1
	      }
	    },
	    arrow: (_arrow = {
	      color: theme.palette.primary.main,
	      transform: 'scale(2.2)',
	      top: 55
	    }, _arrow[theme.breakpoints.down('xs')] = {
	      top: 40,
	      transform: 'scale(1.4)'
	    }, _arrow['&:hover'] = {
	      color: theme.palette.link.hovering
	    }, _arrow),
	    pagingDot: (_pagingDot = {
	      position: 'relative',
	      color: theme.palette.primary.main,
	      '&:hover': {
	        color: theme.palette.highlight.lightTeal
	      }
	    }, _pagingDot[theme.breakpoints.down('xs')] = {
	      fontSize: '0.85em',
	      top: 15
	    }, _pagingDot)
	  };
	};
	
	var Instagram = function Instagram(props) {
	  var classes = props.classes,
	      items = props.items;
	
	
	  var PrevArrow = function PrevArrow(props) {
	    var className = props.className,
	        style = props.style,
	        onClick = props.onClick;
	
	    return _react2.default.createElement(_chevronLeft2.default, {
	      onClick: onClick,
	      className: (0, _classnames2.default)(className, classes.arrow),
	      style: style
	    });
	  };
	
	  var NextArrow = function NextArrow(props) {
	    var className = props.className,
	        style = props.style,
	        onClick = props.onClick;
	
	    return _react2.default.createElement(_chevronRight2.default, {
	      onClick: onClick,
	      className: (0, _classnames2.default)(className, classes.arrow),
	      style: style
	    });
	  };
	
	  var settings = {
	    dots: true,
	    infinite: true,
	    autoplay: true,
	    speed: 1500,
	    slidesToShow: 5,
	    slidesToScroll: 3,
	    prevArrow: _react2.default.createElement(PrevArrow, null),
	    nextArrow: _react2.default.createElement(NextArrow, null),
	    customPaging: function customPaging() {
	      return _react2.default.createElement(_iosCircleFilled2.default, { className: classes.pagingDot });
	    },
	    responsive: [{
	      breakpoint: 290,
	      settings: {
	        centerMode: true,
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }, {
	      breakpoint: 315,
	      settings: {
	        centerMode: true,
	        slidesToShow: 2,
	        slidesToScroll: 1
	      }
	    }, {
	      breakpoint: 390,
	      settings: {
	        centerMode: true,
	        slidesToShow: 2,
	        slidesToScroll: 1
	      }
	    }, {
	      breakpoint: 600,
	      settings: {
	        centerMode: true,
	        slidesToShow: 3,
	        slidesToScroll: 1
	      }
	    }, {
	      breakpoint: 700,
	      settings: {
	        slidesToShow: 3,
	        slidesToScroll: 3,
	        initialSlide: 2
	      }
	    }, {
	      breakpoint: 960,
	      settings: {
	        slidesToShow: 4,
	        slidesToScroll: 3,
	        initialSlide: 2
	      }
	    }, {
	      breakpoint: 1280,
	      settings: {
	        slidesToShow: 4,
	        slidesToScroll: 3,
	        initialSlide: 2
	      }
	    }]
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.root },
	    items.length && _react2.default.createElement(
	      _reactSlick2.default,
	      settings,
	      items.map(function (_ref, i) {
	        var node = _ref.node;
	
	        return _react2.default.createElement(
	          'div',
	          { className: classes.thumbnailWrapper, key: 'sliderItem' + i },
	          _react2.default.createElement(
	            'a',
	            { href: node.url, target: '_blank' },
	            _react2.default.createElement('img', {
	              className: classes.thumbnail,
	              src: node.thumbnail,
	              style: { objectFit: 'cover' }
	            })
	          )
	        );
	      })
	    )
	  );
	};
	
	Instagram.propTypes = {
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    node: _propTypes2.default.shape({
	      thumbnail: _propTypes2.default.string.isRequired,
	      url: _propTypes2.default.string.isRequired,
	      user: _propTypes2.default.string,
	      date: _propTypes2.default.string.isRequired
	    })
	  }))
	};
	
	exports.default = (0, _withStyles2.default)(styles)(Instagram);
	module.exports = exports['default'];

/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = function styles(theme) {
	  var _workoutBox, _workoutIconWrapper, _workoutIcon, _workoutName, _workoutDescription, _readMore;
	
	  return {
	    workoutBox: (_workoutBox = {
	      width: 250,
	      height: '100%',
	      position: 'relative',
	      paddingBottom: 10
	    }, _workoutBox[theme.breakpoints.down('sm')] = {
	      width: 195,
	      padding: 8
	    }, _workoutBox[theme.breakpoints.down('xs')] = {
	      width: '100%',
	      maxWidth: 220,
	      margin: 'auto'
	    }, _workoutBox),
	    workoutIconWrapper: (_workoutIconWrapper = {
	      height: '30%',
	      marginTop: 15
	    }, _workoutIconWrapper[theme.breakpoints.down('xs')] = {
	      marginTop: 10
	    }, _workoutIconWrapper),
	    workoutIcon: (_workoutIcon = {
	      width: 70,
	      height: 70,
	      display: 'block',
	      fill: '#fff',
	      margin: '0 auto 10px'
	    }, _workoutIcon[theme.breakpoints.down('sm')] = {
	      width: 60,
	      height: 60
	    }, _workoutIcon[theme.breakpoints.down('xs')] = {
	      width: 50,
	      height: 50
	    }, _workoutIcon),
	    workoutName: (_workoutName = {
	      color: '#fff',
	      fontWeight: 500,
	      textAlign: 'center',
	      height: '15%',
	      padding: 10
	    }, _workoutName[theme.breakpoints.down('sm')] = {
	      fontSize: '1.2em',
	      height: '13%'
	    }, _workoutName[theme.breakpoints.down('xs')] = {
	      fontSize: '0.9em',
	      height: '15%',
	      padding: 5
	    }, _workoutName),
	    workoutMentionCount: {
	      color: 'yellow',
	      fontWeight: 500
	    },
	    workoutDescription: (_workoutDescription = {
	      color: theme.palette.text.lighter,
	      textAlign: 'center',
	      fontSize: '0.8em',
	      height: 80,
	      display: 'flex',
	      alignItems: 'center'
	    }, _workoutDescription[theme.breakpoints.down('sm')] = {
	      fontSize: '0.65em'
	    }, _workoutDescription[theme.breakpoints.down('xs')] = {
	      fontSize: '0.65em',
	      height: 65
	    }, _workoutDescription),
	    readMore: (_readMore = {
	      margin: 'auto',
	      display: 'block',
	      color: '#fff',
	      width: '100%',
	      transition: 'background 0.7s, color 0.7s'
	    }, _readMore[theme.breakpoints.down('sm')] = {
	      fontSize: '0.7em'
	    }, _readMore[theme.breakpoints.down('xs')] = {
	      fontSize: '0.7em'
	    }, _readMore['&:hover'] = {
	      background: theme.palette.background.light,
	      color: theme.palette.primary.main
	    }, _readMore)
	  };
	};
	
	var WorkoutBox = function (_React$Component) {
	  _inherits(WorkoutBox, _React$Component);
	
	  function WorkoutBox() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, WorkoutBox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.extractPaletteColor = function (colorPath) {
	      var dotReg = /\./;
	      var palette = colorPath.slice(0, colorPath.search(dotReg));
	      var paletteColor = colorPath.slice(colorPath.search(dotReg) + 1);
	      return {
	        palette: palette,
	        paletteColor: paletteColor
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  WorkoutBox.prototype.render = function render() {
	    var _props = this.props,
	        classes = _props.classes,
	        theme = _props.theme,
	        name = _props.name,
	        to = _props.to,
	        Icon = _props.Icon,
	        description = _props.description,
	        color = _props.color,
	        mentions = _props.mentions;
	
	    var _extractPaletteColor = this.extractPaletteColor(color),
	        palette = _extractPaletteColor.palette,
	        paletteColor = _extractPaletteColor.paletteColor;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: classes.workoutBox,
	        style: { background: theme.palette[palette][paletteColor] }
	      },
	      _react2.default.createElement(
	        'div',
	        { className: classes.workoutIconWrapper },
	        _react2.default.createElement(Icon, { className: classes.workoutIcon, alt: name, title: name })
	      ),
	      _react2.default.createElement(
	        _Typography2.default,
	        { variant: 'headline', className: classes.workoutName },
	        name
	      ),
	      _react2.default.createElement(
	        _Typography2.default,
	        { align: 'center', style: { color: '#fff', paddingTop: 2 } },
	        'Mentioned',
	        ' ',
	        _react2.default.createElement(
	          'span',
	          { className: classes.workoutMentionCount },
	          mentions.length
	        ),
	        ' ',
	        'times'
	      ),
	      _react2.default.createElement(
	        _Typography2.default,
	        { className: classes.workoutDescription },
	        description
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: to },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            size: 'small',
	            className: classes.readMore,
	            style: { background: paletteColor }
	          },
	          'Read More'
	        )
	      )
	    );
	  };
	
	  return WorkoutBox;
	}(_react2.default.Component);
	
	WorkoutBox.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  to: _propTypes2.default.string.isRequired,
	  Icon: _propTypes2.default.func.isRequired,
	  description: _propTypes2.default.string.isRequired,
	  color: _propTypes2.default.string.isRequired,
	  mentions: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles, { withTheme: true })(WorkoutBox);
	module.exports = exports['default'];

/***/ }),

/***/ 925:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouterHashLink = __webpack_require__(824);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _nukaCarousel = __webpack_require__(4041);
	
	var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);
	
	var _squats = __webpack_require__(4273);
	
	var _squats2 = _interopRequireDefault(_squats);
	
	var _yoga = __webpack_require__(4274);
	
	var _yoga2 = _interopRequireDefault(_yoga);
	
	var _running = __webpack_require__(4272);
	
	var _running2 = _interopRequireDefault(_running);
	
	var _WorkoutBox = __webpack_require__(924);
	
	var _WorkoutBox2 = _interopRequireDefault(_WorkoutBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var backgroundImage = 'https://s3-us-west-1.amazonaws.com/healthfulinspired/app/home_workouts2.jpg';
	
	var styles = function styles(theme) {
	  var _headline, _subheading, _workoutBoxContainer, _workoutBoxCarousel, _seeFullList;
	
	  return {
	    backgroundPhoto: {
	      width: '100%',
	      height: '100%',
	      backgroundRepeat: 'no-repeat',
	      backgroundImage: 'url(\'' + backgroundImage + '\')',
	      backgroundSize: 'cover',
	      backgroundAttachment: 'local'
	    },
	    headline: (_headline = {
	      color: '#fff',
	      textTransform: 'uppercase',
	      fontWeight: 700,
	      textAlign: 'center',
	      display: 'block',
	      margin: 'auto'
	    }, _headline[theme.breakpoints.down('xs')] = {
	      fontSize: '1.1em',
	      fontWeight: 500,
	      padding: 0
	    }, _headline),
	    subheading: (_subheading = {
	      color: '#fff',
	      textTransform: 'uppercase',
	      textAlign: 'center',
	      paddingBottom: 10,
	      fontWeight: 300
	    }, _subheading[theme.breakpoints.down('xs')] = {
	      fontSize: '0.7em',
	      maxHeight: 23,
	      padding: 6,
	      marginBottom: 7,
	      fontWeight: 300
	    }, _subheading),
	    workoutBoxContainer: (_workoutBoxContainer = {
	      maxHeight: 280,
	      height: '100%',
	      display: 'flex',
	      justifyContent: 'center',
	      margin: '10px 0'
	    }, _workoutBoxContainer[theme.breakpoints.down('xs')] = {
	      display: 'none'
	    }, _workoutBoxContainer),
	    workoutBoxCarousel: (_workoutBoxCarousel = {
	      display: 'none'
	    }, _workoutBoxCarousel[theme.breakpoints.down('xs')] = {
	      display: 'block',
	      width: '100%',
	      height: 260
	    }, _workoutBoxCarousel),
	    seeFullList: (_seeFullList = {
	      color: '#fff',
	      background: theme.palette.primary.main,
	      textTransform: 'uppercase',
	      display: 'block',
	      margin: 'auto',
	      position: 'relative',
	      top: 20,
	      width: 150,
	      transition: 'background 0.7s, color 0.7s',
	      '&:hover': {
	        background: theme.palette.background.light,
	        color: theme.palette.primary.main
	      }
	    }, _seeFullList[theme.breakpoints.down('xs')] = {
	      fontSize: '0.7em',
	      top: 0
	    }, _seeFullList)
	  };
	};
	
	var WorkoutSlide = function WorkoutSlide(_ref) {
	  var classes = _ref.classes,
	      workoutsMentions = _ref.workoutsMentions;
	
	  var workoutsMentionsMap = workoutsMentions.reduce(function (acc, _ref2) {
	    var node = _ref2.node;
	
	    acc[node.frontmatter.title] = node.frontmatter.mentions;
	    return acc;
	  }, {});
	
	  var workoutExercises = [{
	    name: 'Squats',
	    to: '/squats',
	    Icon: _squats2.default,
	    description: 'Increases muscles mass. Amplifies the muscle-building, fat-burning effect. Promotes quicker burning of calories.',
	    color: 'primary.mainLighter',
	    mentions: workoutsMentionsMap['Squats']
	  }, {
	    name: 'Running',
	    to: '/running',
	    Icon: _running2.default,
	    description: 'Strengthens bones in legs and hips. Improves mood and promotes great sense of accomplishment. Burns calories quickly.',
	    color: 'primary.main',
	    mentions: workoutsMentionsMap['Running']
	  }, {
	    name: 'Power Yoga',
	    to: '/power-yoga',
	    Icon: _yoga2.default,
	    description: 'Releases tension in the body and mind. Promotes intuitive eating. Provides physical, mental, and social benefits for weight loss.',
	    color: 'primary.mainDarker',
	    mentions: workoutsMentionsMap['Power Yoga']
	  }];
	
	  return _react2.default.createElement(
	    'div',
	    { style: { width: '100%', height: '100vh', position: 'relative' } },
	    _react2.default.createElement(
	      'div',
	      { style: { position: 'absolute', width: '100%', height: '100%' } },
	      _react2.default.createElement('div', { className: classes.backgroundPhoto, alt: '' })
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        id: 'workouts',
	        style: {
	          position: 'absolute',
	          width: '100%',
	          height: '100%',
	          display: 'flex',
	          justifyContent: 'center',
	          alignItems: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { style: { position: 'relative' } },
	        _react2.default.createElement(
	          _Typography2.default,
	          { variant: 'display2', className: classes.headline },
	          'Workout Exercises'
	        ),
	        _react2.default.createElement(
	          _Typography2.default,
	          {
	            variant: 'title',
	            align: 'center',
	            className: classes.subheading
	          },
	          'Curated For Weight Loss'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.workoutBoxContainer },
	          workoutExercises.map(function (props, i) {
	            return _react2.default.createElement(_WorkoutBox2.default, _extends({ key: 'workout_box' + i }, props));
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.workoutBoxCarousel },
	          _react2.default.createElement(
	            'div',
	            { style: { width: '80vw', minHeight: '100%' } },
	            _react2.default.createElement(
	              _nukaCarousel2.default,
	              {
	                cellSpacing: 10,
	                speed: 700,
	                autoplayInterval: 3000,
	                renderCenterLeftControls: null,
	                renderBottomCenterControls: null,
	                renderCenterRightControls: null,
	                slidesToScroll: 1,
	                initialSlideHeight: 260,
	                swiping: true,
	                wrapAround: true,
	                autoplay: true
	              },
	              workoutExercises.map(function (props, i) {
	                return _react2.default.createElement(_WorkoutBox2.default, _extends({ key: 'workouts_carousel_slide' + i }, props));
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactRouterHashLink.HashLink,
	          { to: '/weight-loss-workouts' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: classes.seeFullList,
	              size: 'small',
	              variant: 'raised'
	            },
	            'See full list'
	          )
	        )
	      )
	    )
	  );
	};
	
	WorkoutSlide.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  workoutsMentions: _propTypes2.default.array.isRequired
	};
	
	exports.default = (0, _withStyles2.default)(styles)(WorkoutSlide);
	module.exports = exports['default'];

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _pinterestP = __webpack_require__(149);
	
	var _pinterestP2 = _interopRequireDefault(_pinterestP);
	
	var _twitter = __webpack_require__(150);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _socialInstagram = __webpack_require__(346);
	
	var _socialInstagram2 = _interopRequireDefault(_socialInstagram);
	
	var _googlePlus = __webpack_require__(148);
	
	var _googlePlus2 = _interopRequireDefault(_googlePlus);
	
	var _facebook = __webpack_require__(147);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _Section = __webpack_require__(173);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _ConnectItem = __webpack_require__(519);
	
	var _ConnectItem2 = _interopRequireDefault(_ConnectItem);
	
	var _goToUrl = __webpack_require__(289);
	
	var _goToUrl2 = _interopRequireDefault(_goToUrl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Connect = function Connect(_ref) {
	  var header = _ref.header;
	
	  var items = [{ Icon: _pinterestP2.default, url: ("https://www.pinterest.com/healthfulinspired/"), title: 'Pinterest' }, { Icon: _facebook2.default, url: ("https://www.facebook.com/healthfulinspired/"), title: 'Facebook' }, { Icon: _twitter2.default, url: ("https://twitter.com/healthfulinspir/"), title: 'Twitter' }, {
	    Icon: _socialInstagram2.default,
	    url: ("https://www.instagram.com/healthfulinspired/"),
	    title: 'Instagram'
	  }, {
	    Icon: _googlePlus2.default,
	    url: ("https://plus.google.com/u/0/115535737505938510496/"),
	    title: 'Google Plus'
	  }];
	  return _react2.default.createElement(_Section2.default, {
	    header: header,
	    render: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        items.map(function (_ref2, i) {
	          var Icon = _ref2.Icon,
	              url = _ref2.url,
	              title = _ref2.title;
	          return _react2.default.createElement(_ConnectItem2.default, {
	            key: 'socialMediaSidebarItem' + i,
	            Icon: Icon,
	            url: url,
	            title: title,
	            onClick: (0, _goToUrl2.default)(url)
	          });
	        })
	      );
	    }
	  });
	};
	
	exports.default = (0, _pure2.default)(Connect);
	module.exports = exports['default'];

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    item: {
	      position: 'relative',
	      minHeight: 40,
	      paddingLeft: 7,
	      cursor: 'pointer',
	      transition: 'background 1s',
	      marginBottom: 5,
	      border: '1px solid ' + theme.palette.borders.cloud,
	      '&:hover': {
	        background: theme.palette.secondary.main
	      }
	    },
	    pinterest: { '&:hover': { background: theme.palette.social.pinterest } },
	    twitter: { '&:hover': { background: theme.palette.social.twitter } },
	    instagram: { '&:hover': { background: theme.palette.social.instagram } },
	    tumblr: { '&:hover': { background: theme.palette.social.tumblr } },
	    googleplus: { '&:hover': { background: theme.palette.social.googleplus } },
	    socialMediaName: {
	      fontWeight: 300,
	      position: 'absolute',
	      display: 'flex',
	      width: '100%',
	      alignItems: 'center',
	      height: '100%',
	      color: theme.palette.text.main,
	      transition: 'color 0.5s'
	    },
	    iconContainer: {
	      paddingRight: 6,
	      position: 'absolute',
	      display: 'flex',
	      alignItems: 'center',
	      height: '100%',
	      right: 0
	    },
	    icon: {
	      color: theme.palette.primary.main,
	      fontSize: '1.2em',
	      borderWidth: 2,
	      opacity: 0.9,
	      display: 'flex',
	      alignItems: 'center',
	      transition: 'opacity 0.5s'
	    }
	  };
	};
	
	var SocialIcon = function SocialIcon(_ref) {
	  var Icon = _ref.Icon,
	      url = _ref.url,
	      title = _ref.title,
	      className = _ref.className;
	
	  if (!Icon) {
	    throw new Error('You must provide a social media icon.');
	  }
	  if (!url) {
	    throw new Error('Please provide a URL to redirect to.');
	  }
	
	  return _react2.default.createElement(
	    'a',
	    { href: url, target: '_blank', style: { margin: '0 4px' }, title: title },
	    _react2.default.createElement(Icon, { className: className })
	  );
	};
	SocialIcon.propTypes = {
	  Icon: _propTypes2.default.any.isRequired,
	  url: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  className: _propTypes2.default.string.isRequired
	};
	
	var EnhancedSocialIcon = (0, _pure2.default)(SocialIcon);
	
	var ConnectItem = function ConnectItem(_ref2) {
	  var classes = _ref2.classes,
	      Icon = _ref2.Icon,
	      url = _ref2.url,
	      title = _ref2.title,
	      onClick = _ref2.onClick;
	  return _react2.default.createElement(
	    'div',
	    {
	      onClick: onClick,
	      className: classes.item + ' ' + classes[title.toLowerCase().replace(' ', '')]
	    },
	    _react2.default.createElement(
	      _Typography2.default,
	      { variant: 'body1', classes: { body1: classes.socialMediaName } },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.iconContainer },
	      _react2.default.createElement(EnhancedSocialIcon, {
	        Icon: Icon,
	        url: url,
	        title: title,
	        className: classes.icon
	      })
	    ),
	    _react2.default.createElement(
	      'style',
	      null,
	      '\n      .' + classes.item + ':hover .' + classes.socialMediaName + ' {\n        color: #fff;\n      }\n      .' + classes.item + ':hover .' + classes.icon + ' {\n        color: #fff;\n      }\n    '
	    )
	  );
	};
	
	// prettier-ignore
	exports.default = (0, _compose2.default)(_pure2.default, (0, _withStyles2.default)(styles))(ConnectItem);
	module.exports = exports['default'];

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _List = __webpack_require__(250);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(444);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemText = __webpack_require__(446);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _Avatar = __webpack_require__(422);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Section = __webpack_require__(173);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    story: {
	      transition: 'opacity 0.8s',
	      padding: 0,
	      marginBottom: 8,
	      '&:hover': {
	        opacity: 0.5
	      }
	    },
	    storyFrom: {
	      color: theme.palette.featured.onWhite
	    },
	    title: {
	      fontWeight: 400,
	      fontSize: '0.8em'
	    }
	  };
	};
	
	var FeaturedStories = function FeaturedStories(_ref) {
	  var classes = _ref.classes,
	      header = _ref.header,
	      stories = _ref.stories;
	
	  var thumbRatio = { width: 70, height: 70 };
	
	  return stories ? _react2.default.createElement(_Section2.default, {
	    header: header,
	    render: function render() {
	      return _react2.default.createElement(
	        _List2.default,
	        null,
	        stories.edges.map(function (_ref2, i) {
	          var node = _ref2.node;
	          return _react2.default.createElement(
	            _ListItem2.default,
	            {
	              key: 'featuredStories' + (i + 1),
	              component: _gatsbyLink2.default,
	              to: node.fields.slug,
	              className: classes.story
	            },
	            _react2.default.createElement(_Avatar2.default, {
	              component: function component(props) {
	                return _react2.default.createElement(
	                  'div',
	                  _extends({}, props, { style: thumbRatio }),
	                  _react2.default.createElement('img', {
	                    src: node.frontmatter.thumbnail,
	                    alt: '',
	                    title: node.frontmatter.title,
	                    style: _extends({}, thumbRatio, {
	                      borderRadius: '50%',
	                      objectFit: 'cover'
	                    })
	                  })
	                );
	              }
	            }),
	            _react2.default.createElement(_ListItemText2.default, {
	              primary: node.frontmatter.storyFrom,
	              secondary: node.frontmatter.title,
	              classes: {
	                primary: classes.storyFrom,
	                secondary: classes.title
	              }
	            })
	          );
	        })
	      );
	    }
	  }) : null;
	};
	
	FeaturedStories.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  header: _propTypes2.default.string.isRequired,
	  stories: _propTypes2.default.object
	};
	
	exports.default = (0, _withStyles2.default)(styles)(FeaturedStories);
	module.exports = exports['default'];

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(49);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _Tags = __webpack_require__(287);
	
	var _Tags2 = _interopRequireDefault(_Tags);
	
	var _Section = __webpack_require__(173);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopularTags = function PopularTags(_ref) {
	  var header = _ref.header,
	      tags = _ref.tags;
	
	  var tagsWithCounters = generateCounts(accumulateTags(tags));
	
	  var top20Tags = Object.keys(tagsWithCounters).sort(function (a, b) {
	    var tagA = tagsWithCounters[a];
	    var tagB = tagsWithCounters[b];
	    return tagB - tagA;
	  }).slice(0, 20);
	
	  return _react2.default.createElement(_Section2.default, { header: header, render: function render() {
	      return _react2.default.createElement(_Tags2.default, { tags: top20Tags });
	    } });
	};
	
	PopularTags.propTypes = {
	  header: _propTypes2.default.string.isRequired,
	  tags: _propTypes2.default.array
	};
	
	function accumulateTags(allTags) {
	  return allTags.reduce(function (acc, node) {
	    var tags = !!node && 'node' in node ? node.node : node;
	    acc.push.apply(acc, tags.frontmatter.tags);
	    return acc;
	  }, []);
	}
	
	// items = string[]
	function generateCounts(items) {
	  if (!Array.isArray(items)) {
	    throw new Error('You must pass in an iterator in order to generate counts');
	  }
	
	  return items.reduce(function (acc, item) {
	    var copyAcc = _extends({}, acc);
	    if (!copyAcc[item]) copyAcc[item] = 0;
	    typeof copyAcc[item] === 'number' && copyAcc[item]++; // eslint-disable-line
	    return copyAcc;
	  }, {});
	}
	
	exports.default = (0, _pure2.default)(PopularTags);
	module.exports = exports['default'];

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _Phaser = __webpack_require__(132);
	
	var _Phaser2 = _interopRequireDefault(_Phaser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    section: {
	      minHeight: 100,
	      marginBottom: 45
	    },
	    header: {
	      display: 'block'
	    },
	    subheader: {
	      color: theme.palette.secondary.main,
	      fontWeight: 500,
	      fontStyle: 'italic'
	    }
	  };
	};
	
	var SidebarSection = function SidebarSection(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      render = _ref.render,
	      header = _ref.header,
	      subheader = _ref.subheader;
	  return _react2.default.createElement(
	    'div',
	    { className: classes.section },
	    _react2.default.createElement(
	      'div',
	      { className: classes.header },
	      _react2.default.createElement(_Phaser2.default, { color: theme.palette.primary.main, label: header }),
	      subheader && _react2.default.createElement(
	        _Typography2.default,
	        {
	          className: classes.subheader,
	          variant: 'caption',
	          gutterBottom: true
	        },
	        subheader
	      )
	    ),
	    render()
	  );
	};
	
	SidebarSection.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  render: _propTypes2.default.func.isRequired,
	  header: _propTypes2.default.string
	
	  // prettier-ignore
	};exports.default = (0, _compose2.default)((0, _withStyles2.default)(styles, { withTheme: true }))(SidebarSection);
	module.exports = exports['default'];

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _PopularTags = __webpack_require__(521);
	
	var _PopularTags2 = _interopRequireDefault(_PopularTags);
	
	var _Connect = __webpack_require__(518);
	
	var _Connect2 = _interopRequireDefault(_Connect);
	
	var _FeaturedStories = __webpack_require__(520);
	
	var _FeaturedStories2 = _interopRequireDefault(_FeaturedStories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      color: theme.palette.primary.dark
	    },
	    linkText: {
	      fontFamily: 'Roboto',
	      fontSize: '0.9em'
	    },
	    latestPostsHeader: {
	      color: theme.palette.primary.main
	    },
	    readMoreLink: {
	      color: theme.palette.primary.main,
	      textTransform: 'uppercase',
	      fontSize: '0.9em'
	    }
	  };
	};
	
	var Sidebar = function Sidebar(_ref) {
	  var classes = _ref.classes,
	      theme = _ref.theme,
	      posts = _ref.posts,
	      tags = _ref.tags,
	      featuredStories = _ref.featuredStories;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.root },
	    _react2.default.createElement(_Connect2.default, { header: 'Connect' }),
	    tags && _react2.default.createElement(_PopularTags2.default, { header: 'Hot Tags', tags: tags }),
	    _react2.default.createElement(_FeaturedStories2.default, { header: 'Featured Stories', stories: featuredStories }),
	    _react2.default.createElement(
	      'style',
	      null,
	      '\n        a {\n          color: ' + theme.palette.primary.main + ';\n        }\n      '
	    )
	  );
	};
	
	Sidebar.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired,
	  posts: _propTypes2.default.array,
	  tags: _propTypes2.default.array,
	  featuredStories: _propTypes2.default.object,
	  thumbResolutions: _propTypes2.default.object
	
	  // prettier-ignore
	};exports.default = (0, _compose2.default)((0, _withStyles2.default)(styles, { withTheme: true }))(Sidebar);
	module.exports = exports['default'];

/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(64);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _reduxForm = __webpack_require__(127);
	
	var _Input = __webpack_require__(67);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _LinearProgress = __webpack_require__(159);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	var _androidCheckmarkCircle = __webpack_require__(208);
	
	var _androidCheckmarkCircle2 = _interopRequireDefault(_androidCheckmarkCircle);
	
	var _errorOutline = __webpack_require__(730);
	
	var _errorOutline2 = _interopRequireDefault(_errorOutline);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _app = __webpack_require__(131);
	
	var _regexp = __webpack_require__(290);
	
	var _regexp2 = _interopRequireDefault(_regexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = function styles(theme) {
	  var _form, _inputsContainer, _inputs, _emailInput, _subscribeButton, _successText, _errorText;
	
	  return {
	    form: (_form = {
	      width: '100%',
	      height: '100%'
	    }, _form[theme.breakpoints.down('xs')] = {
	      width: '95%'
	    }, _form),
	    inputsContainer: (_inputsContainer = {}, _inputsContainer[theme.breakpoints.down('xs')] = {
	      padding: 0
	    }, _inputsContainer),
	    inputs: (_inputs = {
	      border: '1px solid #cbcbcb',
	      width: '100%',
	      textTransform: 'uppercase',
	      fontSize: 16,
	      textAlign: 'center'
	    }, _inputs[theme.breakpoints.down('xs')] = {
	      padding: 4,
	      fontSize: 12
	    }, _inputs),
	    emailInput: (_emailInput = {
	      fontWeight: 400,
	      width: '100%',
	      fontFamily: 'Roboto',
	      textAlign: 'center',
	      background: theme.palette.background.light,
	      color: theme.palette.text.soft
	    }, _emailInput[theme.breakpoints.down('xs')] = {
	      fontSize: '1em',
	      padding: 8
	    }, _emailInput['&::placeholder'] = {
	      color: theme.palette.text.soft,
	      opacity: 1,
	      textAlign: 'center',
	      fontFamily: 'Roboto',
	      fontWeight: 400,
	      fontSize: '0.85em',
	      textTransform: 'uppercase'
	    }, _emailInput),
	    subscribeButton: (_subscribeButton = {
	      border: '1px solid #000',
	      fontFamily: 'Roboto',
	      cursor: 'pointer',
	      fontWeight: 400,
	      fontSize: '0.85em',
	      background: theme.palette.background.dark,
	      color: '#fff',
	      transition: 'background 0.6s',
	      '&:hover': {
	        background: theme.palette.success
	      }
	    }, _subscribeButton[theme.breakpoints.down('xs')] = {
	      fontSize: '0.7em',
	      padding: 7
	    }, _subscribeButton),
	    successText: (_successText = {
	      textAlign: 'center',
	      color: theme.palette.successLighter
	    }, _successText[theme.breakpoints.down('xs')] = {
	      fontSize: '0.75em'
	    }, _successText),
	    errorText: (_errorText = {
	      flexGrow: 1,
	      fontFamily: 'Roboto',
	      textAlign: 'center',
	      color: theme.palette.error.light,
	      marginTop: 4
	    }, _errorText[theme.breakpoints.down('xs')] = {
	      marginTop: 6,
	      fontSize: '0.8em'
	    }, _errorText),
	    checkIcon: {
	      color: theme.palette.successLighter,
	      fontSize: '1.6em'
	    },
	    errorIcon: {
	      color: theme.palette.error.main,
	      fontSize: '1.6em'
	    }
	  };
	};
	
	var renderInputField = function renderInputField(_ref) {
	  var input = _ref.input,
	      _ref$meta = _ref.meta,
	      touched = _ref$meta.touched,
	      error = _ref$meta.error,
	      errorTextClassName = _ref.errorTextClassName,
	      customProps = _objectWithoutProperties(_ref, ['input', 'meta', 'errorTextClassName']);
	
	  return _react2.default.createElement(_Input2.default, _extends({ error: touched && !!error }, input, customProps));
	};
	
	var HomeSubscribeForm = function HomeSubscribeForm(_ref2) {
	  var classes = _ref2.classes,
	      submitting = _ref2.submitting,
	      handleSubmit = _ref2.handleSubmit,
	      submitSucceeded = _ref2.submitSucceeded,
	      anyTouched = _ref2.anyTouched,
	      valid = _ref2.valid,
	      error = _ref2.error;
	
	  var actionProps = {};
	  var oldBrowser = false;
	
	  if (typeof Promise !== 'undefined' && Promise.toString().indexOf('[native code]') !== -1) {
	    actionProps.onSubmit = handleSubmit;
	  } else {
	    oldBrowser = true;
	    actionProps.action = ("https://app.getresponse.com/add_subscriber.html");
	    actionProps.method = 'post';
	  }
	
	  return _react2.default.createElement(
	    'form',
	    _extends({
	      style: { opacity: submitting ? 0.4 : 1 },
	      className: classes.form
	    }, actionProps),
	    _react2.default.createElement(
	      'div',
	      { className: classes.inputsContainer },
	      _react2.default.createElement(_LinearProgress2.default, {
	        color: 'secondary',
	        style: {
	          position: 'relative',
	          width: '100%',
	          marginBottom: 5,
	          visibility: submitting ? 'visible' : 'hidden'
	        }
	      }),
	      !submitSucceeded && _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexDirection: 'row' } },
	        !oldBrowser && _react2.default.createElement(_reduxForm.Field, {
	          errorTextClassName: classes.errorText,
	          classes: { input: classes.emailInput, root: classes.inputs },
	          name: 'email',
	          type: 'email',
	          component: renderInputField,
	          placeholder: 'Your Email',
	          disableUnderline: true,
	          required: true
	        }),
	        oldBrowser && _react2.default.createElement(_Input2.default, {
	          inputProps: {
	            className: (0, _classnames2.default)(classes.inputs, classes.emailInput)
	          },
	          name: 'email',
	          type: 'email',
	          placeholder: 'Your Email',
	          disableUnderline: true,
	          required: true
	        }),
	        oldBrowser && _react2.default.createElement('input', {
	          type: 'hidden',
	          name: 'thankyou_url',
	          value: window.location.href
	        }),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('input', { type: 'hidden', name: 'campaign_token', value: '6qdpg' }),
	        _react2.default.createElement('input', {
	          className: (0, _classnames2.default)(classes.inputs, classes.subscribeButton),
	          type: 'submit',
	          value: 'Subscribe Me'
	        })
	      )
	    ),
	    submitSucceeded && !error && _react2.default.createElement(
	      _Typography2.default,
	      { className: classes.successText },
	      _react2.default.createElement(_androidCheckmarkCircle2.default, { className: classes.checkIcon }),
	      ' You\'re all set!'
	    ),
	    anyTouched && !valid && error && _react2.default.createElement(
	      _Typography2.default,
	      { className: classes.errorText },
	      _react2.default.createElement(_errorOutline2.default, { className: classes.errorIcon }),
	      '\xA0',
	      error
	    )
	  );
	};
	
	HomeSubscribeForm.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  subscribe: _propTypes2.default.func.isRequired,
	  sendAlert: _propTypes2.default.func.isRequired
	};
	
	exports.default = (0, _compose2.default)((0, _withStyles2.default)(styles), (0, _reactRedux.connect)(null, { subscribe: _app.subscribe, sendAlert: _app.sendAlert }), (0, _reduxForm.reduxForm)({
	  form: 'HomeSubscribeForm',
	  onSubmit: function onSubmit(values, _, _ref3) {
	    var subscribeUser = _ref3.subscribe,
	        reset = _ref3.reset,
	        sendAlert = _ref3.sendAlert;
	    return subscribeUser(_extends({ campaignToken: '6qdpg' }, values)).then(function () {
	      sendAlert({
	        message: "Awesome! You're now subscribed.",
	        type: 'success'
	      });
	      return reset();
	    }).catch(function (error) {
	      console.error(error);
	      var message = 'Either the email is already registered or an error occurred. Please try again later.';
	      sendAlert({ message: message, type: 'error' });
	      throw new _reduxForm.SubmissionError({ _error: message });
	    });
	  },
	  validate: function validate(_ref4) {
	    var email = _ref4.email;
	
	    var errors = {};
	    if (!email) {
	      errors._error = 'Please provide your email.';
	    }
	    if (!_regexp2.default.email.test(email)) {
	      errors._error = 'Please provide a valid email.';
	    }
	    return errors;
	  }
	}))(HomeSubscribeForm);
	module.exports = exports['default'];

/***/ }),

/***/ 4272:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2);
	
	function Running (props) {
	    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("g",{"id":"_x33_6_24_"},React.createElement("g",null,[React.createElement("path",{"d":"M150.463,109.521h150.512c3.955,0,7.16-3.206,7.16-7.161c0-3.955-3.205-7.161-7.16-7.161H150.463\n\t\t\t\tc-3.955,0-7.161,3.206-7.161,7.161C143.302,106.315,146.508,109.521,150.463,109.521z","key":0}),React.createElement("path",{"d":"M15.853,179.537h150.511c3.955,0,7.161-3.206,7.161-7.161s-3.206-7.16-7.161-7.16H15.853\n\t\t\t\tc-3.955,0-7.161,3.205-7.161,7.16S11.898,179.537,15.853,179.537z","key":1}),React.createElement("path",{"d":"M56.258,253.214c0,3.955,3.206,7.162,7.161,7.162H213.93c3.955,0,7.161-3.207,7.161-7.162s-3.206-7.16-7.161-7.16H63.419\n\t\t\t\tC59.464,246.054,56.258,249.259,56.258,253.214z","key":2}),React.createElement("path",{"d":"M142.396,336.44H7.161C3.206,336.44,0,339.645,0,343.6s3.206,7.161,7.161,7.161h135.235c3.955,0,7.161-3.206,7.161-7.161\n\t\t\t\tS146.351,336.44,142.396,336.44z","key":3}),React.createElement("path",{"d":"M385.729,154.418c21.6,0,39.111-17.513,39.111-39.114s-17.512-39.113-39.111-39.113\n\t\t\t\tc-21.605,0-39.119,17.513-39.119,39.113C346.609,136.905,364.123,154.418,385.729,154.418z","key":4}),React.createElement("path",{"d":"M450.066,143.155c-22.459,31.459-52.533,35.102-84.895,15.89c-2.203-1.306-11.977-6.691-14.141-7.977\n\t\t\t\tc-52.061-30.906-104.061-18.786-138.934,30.05c-14.819,20.771,19.455,40.459,34.108,19.93\n\t\t\t\tc18.018-25.232,40.929-32.533,65.986-24.541c-12.83,22.27-24.047,44.405-39.875,75.853\n\t\t\t\tc-15.832,31.448-50.787,56.562-84.374,36.92c-24.235-14.165-46.09,20.651-21.928,34.772\n\t\t\t\tc45.854,26.799,99.619,10.343,127.066-24.493c0.952,0.509,1.958,0.968,3.062,1.354c22.422,7.812,51.814,28.61,60.77,35.981\n\t\t\t\tc8.953,7.371,24.336,44.921,33.471,63.788c11.082,22.893,46.871,6.219,35.748-16.771c-10.355-21.406-27.736-64.129-41.293-74.938\n\t\t\t\tc-10.875-8.669-31.988-24.803-49.895-33.956c12.115-23.466,24.729-46.679,38.008-69.491\n\t\t\t\tc42.328,12.969,82.561-2.308,111.215-42.446C498.996,142.312,464.73,122.624,450.066,143.155z","key":5})]))),React.createElement("g",{"key":1}),React.createElement("g",{"key":2}),React.createElement("g",{"key":3}),React.createElement("g",{"key":4}),React.createElement("g",{"key":5}),React.createElement("g",{"key":6}),React.createElement("g",{"key":7}),React.createElement("g",{"key":8}),React.createElement("g",{"key":9}),React.createElement("g",{"key":10}),React.createElement("g",{"key":11}),React.createElement("g",{"key":12}),React.createElement("g",{"key":13}),React.createElement("g",{"key":14}),React.createElement("g",{"key":15})]);
	}
	
	Running.displayName = "Running";
	
	Running.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"487.811px","height":"487.81px","viewBox":"0 0 487.811 487.81","style":{"enableBackground":"new 0 0 487.811 487.81"},"xmlSpace":"preserve"};
	
	module.exports = Running;
	
	Running.default = Running;


/***/ }),

/***/ 4273:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2);
	
	function Squats (props) {
	    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M402.027,116.532h-63.536h-68.923v-0.012v-0.43c0-0.693-0.097-1.384-0.181-2.054c9.428-11.997,15.145-27.042,15.145-43.447\n\t\tC284.532,31.667,252.85,0,213.939,0c-38.917,0-70.583,31.667-70.583,70.59c0,16.393,5.698,31.402,15.102,43.405\n\t\tc-0.057,0.505-0.144,0.994-0.144,1.511v1.021v0.015H89.553H26.01c-5.468,1.222-9.617,6.074-9.617,12.058\n\t\tc0.018,6.917,5.446,12.511,12.169,12.511h5.987H55.83h88.694h13.778v0.087v129.871H95.621c-19.333,0-35.068,15.673-35.158,34.984\n\t\tv86.829c0,19.39,15.778,35.164,35.17,35.164c19.393,0,35.179-15.769,35.179-35.164v-51.461h27.502h24.659h30.967h30.973h24.662\n\t\th28.865v51.461c0,19.39,15.792,35.164,35.182,35.164c19.401,0,35.164-15.769,35.164-35.164v-86.637\n\t\tc0-19.396-15.763-35.183-35.164-35.183h-64.053V141.191v-0.087h13.942h88.703h21.281h5.98c6.726,0,12.166-5.593,12.178-12.511\n\t\tC411.641,122.609,407.498,117.757,402.027,116.532z"})),React.createElement("g",{"key":1}),React.createElement("g",{"key":2}),React.createElement("g",{"key":3}),React.createElement("g",{"key":4}),React.createElement("g",{"key":5}),React.createElement("g",{"key":6}),React.createElement("g",{"key":7}),React.createElement("g",{"key":8}),React.createElement("g",{"key":9}),React.createElement("g",{"key":10}),React.createElement("g",{"key":11}),React.createElement("g",{"key":12}),React.createElement("g",{"key":13}),React.createElement("g",{"key":14}),React.createElement("g",{"key":15})]);
	}
	
	Squats.displayName = "Squats";
	
	Squats.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"428.046px","height":"428.046px","viewBox":"0 0 428.046 428.046","style":{"enableBackground":"new 0 0 428.046 428.046"},"xmlSpace":"preserve"};
	
	module.exports = Squats;
	
	Squats.default = Squats;


/***/ }),

/***/ 4274:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2);
	
	function Yoga (props) {
	    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M260.422,314.065c-3.338-0.517-5.858-0.875-7.909-1.164c-6.301-0.895-7.993-1.135-15.359-3.428\n\t\tc-2.903-0.904-14.259-12.358-14.259-34.775c0-28.879,6.857-54.382,9.803-64.005c0.078-0.251,0.27-0.978,0.536-1.962\n\t\tc0.487-1.807,4.062-12.719,4.062-12.719c1.938-5.551,3.944-11.293,5.247-17.191l0.07-0.302c1.967-8.54,8.424-39.756,8.882-82.935\n\t\tc0-4.357-3.622-8.148-5.785-10.412c-0.396-0.416-0.747-0.78-1.009-1.086c-2.083-2.422-4.825-5.412-8.001-8.872\n\t\tc-2.092-2.282-4.396-4.796-6.879-7.546c-3.972-4.393-8.401-8.412-12.686-12.297c-5.269-4.775-10.714-9.713-15.189-15.28\n\t\tc-6.688-8.317-12.871-22.874-11.752-34.606c0.17-1.77-0.243-3.299-1.162-4.309c-1.02-1.123-2.62-1.473-4.029-0.916\n\t\tc-1.411-0.557-3.012-0.207-4.03,0.916c-0.918,1.01-1.333,2.539-1.161,4.309c1.117,11.732-5.066,26.289-11.752,34.606\n\t\tc-4.477,5.567-9.922,10.505-15.191,15.28c-4.283,3.885-8.715,7.904-12.685,12.297c-2.482,2.75-4.789,5.264-6.88,7.546\n\t\tc-3.177,3.46-5.917,6.45-8.002,8.872c-0.262,0.306-0.61,0.67-1.007,1.086c-2.163,2.264-5.786,6.055-5.786,10.434\n\t\tc0.459,43.157,6.916,74.373,8.883,82.913l0.069,0.302c1.303,5.898,3.31,11.641,5.246,17.191c0,0,3.574,10.912,4.061,12.719\n\t\tc0.267,0.984,0.46,1.711,0.538,1.962c2.945,9.623,9.801,35.126,9.801,64.005c0,22.418-11.355,33.871-14.257,34.775\n\t\tc-7.366,2.293-9.059,2.533-15.361,3.428c-2.051,0.289-4.569,0.647-7.907,1.164c-36.177,3.85-40.083,21.809-40.083,29.353\n\t\tc0,2.022,1.047,8.592,5.822,14.649c4.291,5.442,12.837,11.933,29.195,11.933c2.454,0,5.05-0.146,7.718-0.434\n\t\tc10.887-1.17,21.859-2.928,32.468-4.627c3.854-0.617,7.701-1.233,11.555-1.824c5.134-0.787,14.387-1.309,27.498-1.549\n\t\tc0.614-0.012,1.041-0.021,1.248-0.027c0.207,0.006,0.634,0.016,1.246,0.027c13.113,0.24,22.365,0.762,27.5,1.549\n\t\tc3.852,0.591,7.7,1.207,11.553,1.824c10.61,1.699,21.583,3.457,32.468,4.627c2.668,0.287,5.264,0.434,7.718,0.434\n\t\tc16.361,0,24.909-6.488,29.197-11.933c4.775-6.056,5.82-12.628,5.82-14.649C300.503,335.874,296.599,317.915,260.422,314.065z\n\t\t M204.132,167.036c-0.539,0-1.05-0.117-1.567-0.362c-1.683-0.671-3.841-3.886-4.042-5.134c8.382-5.832,14.045-16.91,14.045-29.625\n\t\tc0-18.777-1.982-34-27.567-34s-27.567,15.223-27.567,34c0,12.715,5.663,23.793,14.044,29.625c-0.197,1.245-2.404,4.307-4.041,5.134\n\t\tc-0.516,0.245-1.026,0.362-1.567,0.362c-5.387,0.002-12.139-11.797-13.912-16.492c-3.021-7.977-6.792-21.688-7.601-41.697\n\t\tl-0.033-0.77c-0.207-4.215,6.142-14.994,6.983-16.838c1.156-2.539,16.154-25.4,20.608-30.816\n\t\tc1.577-1.915,9.566-12.523,13.087-17.205c3.52,4.682,11.508,15.29,13.084,17.205c4.457,5.416,19.451,28.277,20.609,30.816\n\t\tc0.842,1.844,7.191,12.623,6.985,16.838l-0.033,0.77c-0.81,20.01-4.579,33.721-7.603,41.697\n\t\tC216.271,155.238,209.521,167.036,204.132,167.036z"})),React.createElement("g",{"key":1}),React.createElement("g",{"key":2}),React.createElement("g",{"key":3}),React.createElement("g",{"key":4}),React.createElement("g",{"key":5}),React.createElement("g",{"key":6}),React.createElement("g",{"key":7}),React.createElement("g",{"key":8}),React.createElement("g",{"key":9}),React.createElement("g",{"key":10}),React.createElement("g",{"key":11}),React.createElement("g",{"key":12}),React.createElement("g",{"key":13}),React.createElement("g",{"key":14}),React.createElement("g",{"key":15})]);
	}
	
	Yoga.displayName = "Yoga";
	
	Yoga.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 370.001 370.001","style":{"enableBackground":"new 0 0 370.001 370.001"},"xmlSpace":"preserve"};
	
	module.exports = Yoga;
	
	Yoga.default = Yoga;


/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.QueryHome = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Meta = __webpack_require__(48);
	
	var _WorkoutSlide = __webpack_require__(925);
	
	var _WorkoutSlide2 = _interopRequireDefault(_WorkoutSlide);
	
	var _ArticlesSlide = __webpack_require__(922);
	
	var _ArticlesSlide2 = _interopRequireDefault(_ArticlesSlide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data;
	  var siteMetadata = data.site.siteMetadata,
	      articles = data.articles.edges,
	      tags = data.tags.edges,
	      featuredStories = data.featuredStories,
	      workoutsMentions = data.workoutsMentions.edges;
	
	  // const sortedInstagramPosts = orderBy(
	  //   instagramPosts.edges,
	  //   ({ node }) => node.date,
	  //   ['desc'],
	  // )
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Meta.RootMeta, {
	      url: siteMetadata.siteUrl,
	      title: 'Home | ' + siteMetadata.siteName,
	      description: siteMetadata.siteDescription
	    }),
	    _react2.default.createElement(_ArticlesSlide2.default
	    // instagramPosts={sortedInstagramPosts}
	    , { articles: articles,
	      tags: tags,
	      featuredStories: featuredStories
	    }),
	    _react2.default.createElement(_WorkoutSlide2.default, { workoutsMentions: workoutsMentions })
	  );
	};
	// import StoriesSlide from 'components/Frontpage/StoriesSlide'
	
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	
	  // prettier-ignore
	  // eslint-disable-next-line
	};var QueryHome = exports.QueryHome = '** extracted graphql fragment **';
	
	exports.default = IndexPage;

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function formatCategory(category) {
	  if (typeof category !== 'string') {
	    throw new Error('Category cannot be empty');
	  }
	  var categoryStripped = category.replace(/\//g, '');
	
	  switch (categoryStripped) {
	    case 'health-wellness':
	      return 'Wellness';
	    case 'health-fitness':
	      return 'Fitness';
	    case 'health-food':
	      return 'Food';
	    default:
	      return null;
	  }
	}
	
	exports.default = formatCategory;
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getRandomColor = function getRandomColor() {
	  var letters = '0123456789ABCDEF';
	  var color = '#';
	  for (var i = 0; i < 6; i++) {
	    color += letters[Math.floor(Math.random() * 16)];
	  }
	  return color;
	};
	
	exports.default = getRandomColor;
	module.exports = exports['default'];

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(28);
	
	function goToUrl(url) {
	  return function () {
	    if (/^http/.test(url)) {
	      // eslint-disable-next-line
	      return window.open(url, '_blank');
	    }
	    return (0, _gatsbyLink.navigateTo)(url);
	  };
	}
	
	exports.default = goToUrl;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4f11bec9e2619c489bf8.js